! function(e) {
        e.fn.prepareTransition = function() { 
            return this.each(function() {
                var t = e(this);
                t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
                    t.removeClass("is-transitioning")
                });
                var n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                    i = 0;
                e.each(n, function(e, n) {
                    i || (i = parseFloat(t.css(n)))
                }), 0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth)
            })
        }
}(jQuery);

var jQuery = jQuery.noConflict();
window.poshecommerce = window.poshecommerce || {};
poshecommerce.init = function() {
  
  poshecommerce.customerTemplates.init();
  poshecommerce.rte.wrapTable();
  poshecommerce.rte.iframeReset();
  
  poshecommerce.cartModal(); // cart Modal
  poshecommerce.mobileSideNav(); // MobileSide Nav  
  //poshecommerce.mobileSideNavDrawer.init();
  poshecommerce.cartDrawer.init(); // Cart Drawer
  poshecommerce.multiAddToCart.init(); // Multiple Add To cart
  poshecommerce.sidebarDropdown(); // Sidebar Dropdown
  poshecommerce.footerDropdown(); // Footer Dropdown
  poshecommerce.changeView.init(); // Grid/List Change View
  poshecommerce.scroll.init(); // Scroll Header and MiniCart
  poshecommerce.brandSlider.init(); // Brand Slider
  poshecommerce.browseCategories.init(); // Category Slider
  poshecommerce.cookiePolicy();
  poshecommerce.responsiveTabs.init();
  poshecommerce.responsiveTabs.productTabs();
  poshecommerce.Search.init();
  poshecommerce.brandList(); // Shop By Brand List
  poshecommerce.quickOrders(); // Quick Order List
  poshecommerce.collectionSwatches.init();
  poshecommerce.searchModal(); // Search Modal
  poshecommerce.searchAutoComplete();
  poshecommerce.productGridCounter.init();
  poshecommerce.quickShop.init();
  poshecommerce.HoverMenu();
  poshecommerce.settingMenu();
  if(poshecommerce.displaySuggestProduct){
    var suggested_closed = getCookie("suggested_product");
    if (suggested_closed != 'closed') {
       
	
        if(poshecommerce.displayDevice == "both"){
            poshecommerce.suggestProduct.init();
        }
        else{
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
              if(poshecommerce.displayDevice == "only_mobile"){
                poshecommerce.suggestProduct.init();
              }
            }
            else{
              if(poshecommerce.displayDevice == "only_desktop"){
                poshecommerce.suggestProduct.init();
              }
            }
        }
  	}
  }
  // Common a11y fixes
  poshecommerce.a11y.pageLinkFocus(jQuery(window.location.hash));

  jQuery('.in-page-link').on('click', function(evt) {
    poshecommerce.a11y.pageLinkFocus(jQuery(evt.currentTarget.hash));
  });

  jQuery('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });
  
  if(jQuery('.parallax-hero').length){     
     poshecommerce.parallaxImage.init();
  }
};
poshecommerce.cookiePolicy = function(){
  if(jQuery('.cookie_banner-wrapper').length){
    var cookie_consent_accepted = getCookie("cookie_policy_accepted");
    if(cookie_consent_accepted == 'yes') {
      jQuery('.cookie_banner-wrapper').remove();
    }
    jQuery('.cookie_banner-wrapper a.cookie_accept').bind('click',function(){
      jQuery('.cookie_banner-wrapper').remove();
      createCookie("cookie_policy_accepted","yes", 365);
    });
  }
};
poshecommerce.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  jQuery(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};


poshecommerce.Sections.prototype = _.assignIn({}, poshecommerce.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = jQuery(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = jQuery('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    jQuery('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

poshecommerce.rte = {
  wrapTable: function() {
    jQuery('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = jQuery('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      jQuery(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};


/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

poshecommerce.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus(jQuery(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    jQuery('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus(jQuery(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    jQuery(document).off('focusin');

    jQuery(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    jQuery(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

poshecommerce.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }
    if (size === 'master') {
      return this.removeProtocol(src);
    }
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }
    return null;
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();



/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

poshecommerce.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

poshecommerce.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
	
    jQuery(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(jQuery(this.singleOptionSelector, this.$container), function(element) {
     
        var $element = jQuery(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      jQuery(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();



/* Collection Color Swatch Swap Image Start*/
poshecommerce.collectionSwatches = (function() {
  function swapImage()
  {
    jQuery('.swatch_clicked').click(function(){   	
     	var variantImage = jQuery(this).siblings().find(".variant_image").data("image");
      	//var productImage = jQuery(this).parent().parent().parent().find('.grid-view-item__image');
      var productImage = jQuery(this).parent().parent().parent().parent().find('img.hidden');
      productImage.attr('src',variantImage); 
      
  	});
  }
  
  return {
    init: function() {
      swapImage();
    }
  };
})();
/*-- Ended here--*/


/* ================ MODULES ================ */

poshecommerce.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('.arw', function(evt) {
      var $el = jQuery(this);
      evt.preventDefault();

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    jQuery(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (jQuery(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('hover.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
    
    
  }

  function cacheSelectors() {
    cache = {
      $nav: jQuery(selectors.navigation),
      $topLevel: jQuery(selectors.siteNavLinkMain),
      $parents: jQuery(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: jQuery(selectors.siteNavChildLinks),
      $activeDropdown: jQuery(selectors.siteNavActiveDropdown),
      // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart-note__input',

    // Add to cart - Ajax
    $cartCount: jQuery('.cart-count'),
    $addToCartBtn: jQuery('form[action^="/cart/add"] :submit')
    };
  }
  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      jQuery(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      jQuery(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = jQuery(selectors.siteNavActiveDropdown);

    jQuery(selectors.body).off('click.siteNav');
    jQuery(window).off('keyup.siteNav');
  }

  function unload() {
    jQuery(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    jQuery(selectors.siteNavChildLink).off('.siteNav');
    jQuery(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();


// Navigation Mobile Menu

poshecommerce.mobilemenu = (function() {
	var selectors = {    
      	menuToggle: '.menu-toggle',
      	closeIcon: 'close-menu',
      	sitenav: '#AccessibleNav',
      	menuLinks: '#mainMenu .arw'
	};
     
  	jQuery(selectors.menuToggle).on("click",function(){
      if (jQuery(window).width() > 999 ) {
        jQuery(selectors.sitenav).slideToggle();
      }
      jQuery(selectors.sitenav).toggleClass('toggled-on');
    });
  	
	jQuery(selectors.menuLinks).on('click', function(e) {
		e.preventDefault();
		
		jQuery(this).toggleClass('minus');
		jQuery(this).parent().next().slideToggle();
      
    });
  
  function switchmobile(){
    if (jQuery(window).width() < 998) {
        jQuery("#mainMenu ul, #mainMenu .megamenu").attr("style","");
        jQuery("#AccessibleNav").attr("style","");
    }
  		//alert("test switch mobile ");
  }
  
  return {
    switchmobile: switchmobile
  
  };
 
})();

jQuery(window).on('delayed-resize', function (e, resizeEvent) {
      poshecommerce.mobilemenu.switchmobile();
});


(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = jQuery(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

poshecommerce.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = jQuery(el);
   
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
	this.$next =  this.$slideshow.siblings('.slick-next');
    this.$prev =  this.$slideshow.siblings('.slick-prev');
    
    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed') 
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);
    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;
    //console.log(this.settings.autoplay);
	var $nextSlide = this.$next;
    var $prevSlide = this.$prev;
    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');
	$nextSlide.insertAfter('#Slideshow-slideshow .slick-dots');
    $prevSlide.insertAfter('#Slideshow-slideshow .slick-dots');
    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $nextSlide.on('click', function(evt) {
      $slider.slick('slickNext');
    });
    $prevSlide.on('click', function(evt) {
      $slider.slick('slickPrev');
    });
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if (jQuery(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      poshecommerce.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        poshecommerce.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      jQuery(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      jQuery(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  poshecommerce.SlideshowVideo.loadVideos();
}

poshecommerce.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0,
      origin: window.location.href, 
      enablejsapi: 1,
      html5: 1
      
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      // console.log(key);
      if (videos.hasOwnProperty(key)) {
        var args = jQuery.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = jQuery.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    jQuery(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = jQuery.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }
	
    function ismobile(){
       if(/android|webos|iphone|ipad|ipod|blackberry|opera mini|Windows Phone|iemobile|WPDesktop|XBLWP7/i.test(navigator.userAgent.toLowerCase())) {
           return true;
       }
       else
        return false;
    }

    if (jQuery(window).width() < 750) {
      playOnClick = true;
    } else if (ismobile()) {
      
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
      //console.log("mobilecheck");
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    jQuery('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    jQuery('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    jQuery('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    jQuery(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    jQuery('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo(jQuery(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    jQuery('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = jQuery('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    jQuery(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = jQuery(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    jQuery(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = jQuery(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });
    
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    // Listen to resize to keep a background-size:cover-like layout
    jQuery(window).on('resize.videoPlayer', debounce(function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    },250));
  }

  function removeEvents() {
    jQuery(document).off('.videoPlayer');
    jQuery(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = jQuery('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = jQuery(this).val();
  });

})();


poshecommerce.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    jQuery('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    jQuery('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    jQuery('#RecoverPasswordForm').toggleClass('hide');
    jQuery('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = jQuery('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    jQuery('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = jQuery('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    jQuery('.address-country-option').each(function() {
      var formId = jQuery(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    jQuery('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    jQuery('.address-edit-toggle').on('click', function() {
      var formId = jQuery(this).data('form-id');
      jQuery('#EditAddress_' + formId).toggleClass('hide');
    });

    jQuery('.address-delete').on('click', function() {
      var $el = jQuery(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();



jQuery(window).on('load', function() {
 
  var sections = new poshecommerce.Sections();
  sections.register('cart-template', poshecommerce.Cart);
  sections.register('product', poshecommerce.Product);
  sections.register('productswatch-section', poshecommerce.Product);
 // sections.register('productswatch-section', poshecommerce.bannerSwatchSection);
  sections.register('collection-template', poshecommerce.Filters);
  sections.register('product-template', poshecommerce.Product);
  sections.register('header-section', poshecommerce.HeaderSection);
  sections.register('map', poshecommerce.Maps);
  sections.register('slideshow-section', poshecommerce.SlideshowSection);
  sections.register('bestseller-section', poshecommerce.bestsellerSection);
  sections.register('collectionlist-section', poshecommerce.collectionlistSection);
  sections.register('productbanner-section', poshecommerce.productbannerSection);
  sections.register('horiimage-section',poshecommerce.productImagebannerSection);
  sections.register('category-section', poshecommerce.bannerSliderSection);

  sections.register('dealofday-section', poshecommerce.dealofdaySection);
  sections.register('dealofday-section', poshecommerce.Product);
  sections.register('prodcarousel-section', poshecommerce.prodcarouselSection);
  sections.register('quotes', poshecommerce.Quotes);
});

jQuery(window).load(function () {
  if(location.pathname == "/"){ 
    alignProductGridActionsHome();
    alignProductGridActions('.grid__item_parallax');
    
    /*jQuery(".button").on('click', function(evt) {
        var oldValue = jQuery(this).parent().find("input[name='quantity']").val();
        var newVal = 1;
        if (jQuery(this).text() == "+") {
            newVal = parseInt(oldValue) + 1;
        } else if (oldValue > 1) {
            newVal = parseInt(oldValue) - 1;
        }
        jQuery(this).parent().find("input[name='quantity']").val(newVal);
    
      });*/
    
  }else{
    alignProductGridActions('.grid__item_eqh');
  }
  
});

/*================ Back To Top ================*/
jQuery(document).ready(function() {
  	jQuery(poshecommerce.init);
  	if(poshecommerce.enabledWow){
    wow = new WOW( {
        boxClass:     'wow',
        animateClass: 'animated',
        offset:       100
        }
		);

		wow.init();
  	}
    var offset = 220;
    var duration = 500;
  	var round35 = true;
  	var round80 = true;
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > offset) {
            jQuery('.back-to-top').fadeIn(duration);
        } else {
            jQuery('.back-to-top').fadeOut(duration);
        }
      
      // home page items equal height optimized
      if(location.pathname == "/" && poshecommerce.enable_lazyload === 'true'){ 
      	var scrollAmount = jQuery(window).scrollTop();
        var documentHeight = jQuery(document).height();
        var windowHeight = jQuery(window).height();

        var scrollPercent = (scrollAmount / (documentHeight - windowHeight)) * 100;
        var roundScroll = Math.round(scrollPercent);
      	
        if(roundScroll == 35){
          if(round35){
            round35 = false;
            alignProductGridActionsHome();
             alignProductGridActions('.grid__item_parallax');
            
          }
        }
        if(roundScroll == 80){
          if(round80){
            round80 = false;
            alignProductGridActionsHome();
            alignProductGridActions('.grid__item_parallax');
          }
        }
                
      }
      
    });
  
  jQuery( "div[id^='horiImage']" ).click(function(event) {
    var  slideIndex = jQuery(this).index();
     var sectionId = jQuery(this).closest('.prcarousel').attr('data-section-id');
    var slider = jQuery('#productbanner-' + sectionId);
   // jQuery('#productbanner-' + sectionId).slickGoTo( parseInt(slideIndex) );
   //  jQuery('#productbanner-' + sectionId).slick.slickGoTo(parseInt(slideIndex));
   // alert(slideIndex);
    slider[0].slick.slickGoTo(parseInt(slideIndex));


    
  });
    jQuery('.back-to-top').click(function(event) {
        event.preventDefault();
        jQuery('html, body').animate({scrollTop: 0}, duration);
        return false;
    });
    var resizeId;
    var ok_to_resize=true;
    jQuery(window).on('delayed-resize', function (e, resizeEvent) {
      if (ok_to_resize){
        //run your resize code
        ok_to_resize = false;
        clearTimeout(resizeId);
        resizeId = setTimeout(function(){
          ok_to_resize = true;
          // home page items equal height on lazyloaded event(when lazyload in enabled)
          if(location.pathname == "/"){ 
              alignProductGridActionsHome();
              alignProductGridActions('.grid__item_parallax');

          }else{
          	alignProductGridActions('.grid__item_eqh');
          }
        },2500);

      }
    }); //END window.resize
  
  /*  if (jQuery('.grid--view-items').length) {
     
      // home page items equal height on lazyloaded event(when lazyload in enabled)
      if(location.pathname == "/"){ 
        alignProductGridActionsHome();
        alignProductGridActions('.grid__item_parallax');
      }else{
        alignProductGridActions('.grid__item_eqh');
      }
        
	}*/
  
    if(jQuery("#wishlist-products").length){
      var check_cookie_val = getCookie("shopify_wishlist_products");
      if(check_cookie_val == "")
      {
        jQuery("#no_rows").show();
      } 	
    }
  	
  	/* ----- LazyLoad ------ */  
  
    window.lazySizesConfig = window.lazySizesConfig || {};  
	window.lazySizesConfig.lazyClass = 'posh_lazyload';
	window.lazySizesConfig.srcAttr = 'data-src';
  
    /* ----- LazyLoad ------ */
  
	/********* add absolute class ****/
    
    jQuery("#shopify-section-header").addClass("header-top-banner");
  
    /* end */
  	
  
  	
  	jQuery('.faq-title').click(function(){
      if (jQuery(this).parent(".faq-panel").hasClass("open")) {
        jQuery(this).parent(".faq-panel").removeClass("open");
        jQuery(this).siblings(".faq-body").slideUp(500);
      } else {
        jQuery(".faq-panel").removeClass("open");
        jQuery(".faq-panel .faq-body").slideUp(500);
        jQuery(this).parent(".faq-panel").addClass("open");
        jQuery(this).siblings(".faq-body").slideDown(500);
      }
    });
  
  
  	// Test Orders
  	 
  	// End
});

/*================ End Back To Top ================*/



/*================ View More / Less ================*/

viewmorecat()
function viewmorecat(){
jQuery('.categories-box ul , .categories-side ul').each(function(){
    var jQueryul = jQuery(this),
        jQuerylis = jQueryul.find('li:gt(4)'),
        isExpanded = jQueryul.hasClass('expanded');
    jQuerylis[isExpanded ? 'show' : 'hide']();
    
    if(jQuerylis.length > 0){
      jQueryul
      .append(jQuery('<li class="expand"><span>' + (isExpanded ? 'View Less Category' : 'View More Category') + '</span></li>')
              .click(function(event){
        var isExpanded = jQueryul.hasClass('expanded');
        event.preventDefault();
        jQuery(this).text(isExpanded ? 'View More Category' : 'View Less Category');
        jQueryul.toggleClass('expanded');
        jQuerylis.toggle();
      }));
    }
});
}

/*================ View More / Less ================*/
jQuery('.tags ul').each(function(){
    var jQueryul = jQuery(this),
        jQuerylis = jQueryul.find('li:gt(8)'),
        isExpanded = jQueryul.hasClass('expanded');
    jQuerylis[isExpanded ? 'show' : 'hide']();
    
    if(jQuerylis.length > 0){
      jQueryul
      .append(jQuery('<li class="expand"><span>' + (isExpanded ? 'View Less Tags' : 'View More Tags') + '</span></li>')
              .click(function(event){
        var isExpanded = jQueryul.hasClass('expanded');
        event.preventDefault();
        jQuery(this).text(isExpanded ? 'View More Tags' : 'View Less Tags');
        jQueryul.toggleClass('expanded');
        jQuerylis.toggle();
      }));
    }
});

/*================ SECTIONS ================*/

poshecommerce.Cart = (function() {
  var selectors = {
    edit	: '.js-edit-toggle',
    cartQty : '.cart_qty_button'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active'
  };
  
  function Cart(container) {
    this.$container = jQuery(container);
    this.$edit = jQuery(selectors.edit, this.$container);
	
    this.$edit.on('click', this._onEditClick.bind(this));
    /* === Cart Qty increment/decrement JS === */
    jQuery(selectors.cartQty).bind( "click", function() {
        var newVal = 1;
        var curr_id = jQuery(this).closest("[id^='cart_row_']").attr("id");
        var oldValue = jQuery('#cart_table tr#'+curr_id).find('.cart__qty-input').val();

        if (jQuery(this).text() == "+") {
           newVal = parseInt(oldValue) + 1;
        } else if (oldValue > 1) {
           newVal = parseInt(oldValue) - 1;
        }

        jQuery('#cart_table tr#'+curr_id).find('.cart__qty-input').val(newVal);
	});
    /* == End == */
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
     
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      
      var $evtTarget = jQuery(evt.target);
      var $updateLine = jQuery('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    }
  });

  return Cart;
})();

poshecommerce.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by',
    DEFAULT_SORT: 'title-ascending'
  };
  var selectors = {
    filterSelection: '.filters-toolbar__input--filter',
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.collection-header__default-sort'
  };

  function Filters(container) {
    var $container = this.$container = jQuery(container);

    this.$filterSelect = jQuery(selectors.filterSelection, $container);
    this.$sortSelect = jQuery(selectors.sortSelection, $container);
    this.$selects = jQuery(selectors.filterSelection, $container).add(jQuery(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var query = '';

      this.sort = this._getSortValue();
		// changed below lines to Solve Sort Problem in Chrome	
      if (this.sort !== this.defaultSort) {
  		 //  if(window.location.href.indexOf("view") > -1) {
  		//	query = ['?view=' + getParameterByName('view') +'&'+ constants.SORT_BY + '=' + this.sort];
          // }else{
            query = ['?'+ constants.SORT_BY + '=' + this.sort];
            //}
       
  		window.location.href =query;
	  } else {
        	window.location.href = window.location.href.replace(window.location.search, '');
	  }
      //ended here
      this._resizeSelect(jQuery(evt.target));
    },

    _onFilterChange: function(evt) {
      document.location.href = this.$filterSelect.val();
      this._resizeSelect(jQuery(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return jQuery(selectors.defaultSort, this.$container).val() || constants.DEFAULT_SORT;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = jQuery(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = jQuery('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


poshecommerce.HeaderSection = (function() {

  function Header() {
    poshecommerce.Header.init();
  //  poshecommerce.MobileNav.init();
    //poshecommerce.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      poshecommerce.Header.unload();
    }
  });

  return Header;
})();

// Browse Categories Slider

poshecommerce.browseCategories = (function(){
  browseCategoriesEle = {
    slideCategories : '#slide_categories'
  }
  function init(){
    if(jQuery(browseCategoriesEle.slideCategories).length){
      jQuery(browseCategoriesEle.slideCategories).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
              breakpoint: 1024,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
              }
          },
          {
              breakpoint:767,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 640,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
          }
        ]
	 });
    }
  }
  return {
  	init: init,    
  }
}());
poshecommerce.suggestProduct = (function(){
   
  function init(){
      var intervalID;
      var close=0;
      var curNewsIndex = 0;
      function suggestedItems() {
        ++curNewsIndex;
        
        if (curNewsIndex >= suggestHanlde.length) {
          curNewsIndex = 0;
        }
        //setTickerNews(handleArray[curNewsIndex]);   // set new news item into the ticker
        jQuery('#suggest-product').slideToggle("slow", function() {
          
           setTimeout(function() {
             var locationList = poshecommerce.listLocationArray,rand = Math.floor(Math.random() *3);
                var timeCount = Math.floor((Math.random() * 60) + 1);
               jQuery('#suggest-product .product-title').html(suggestTitle[curNewsIndex]).attr('href','/collections/clothing/products/'+suggestHanlde[curNewsIndex]);
                jQuery('#suggest-product .suggest-product-url').attr('href','/collections/clothing/products/'+suggestHanlde[curNewsIndex]);
                 if (suggestImage[curNewsIndex] != 'undefined') {
                    jQuery('#suggest-product .suggest-product-image').attr('src', suggestImage[curNewsIndex]);
                 }
                 if(poshecommerce.fakeTime){             
                	jQuery('#suggest-product .suggest-time').html(timeCount+' minuites ago');
                 }
                 if(poshecommerce.displayLocation){
                	 jQuery('#suggest-product .suggest-location').html('from '+locationList[rand]);
                 }
             if(close==0){
                 jQuery('#suggest-product').slideToggle("slow");
             }
           }, parseInt(poshecommerce.interval)*1500);
        });
      }
     var intervalID = setInterval(suggestedItems, parseInt(poshecommerce.interval)*1000);
   
     jQuery(document).on("click", "#suggest-product .suggestClose", function(){
      close = 1;
      jQuery('#suggest-product').hide();
       clearInterval(intervalID); 
       clearInterval(intervalID); 
       createCookie("suggested_product","closed", 365);
     });
  }
  return {
  	init: init,    
  }
}());
// Brand Slider 

poshecommerce.brandSlider = (function(){
  poshecommerce.brandSliderEle = {
    slideBrand : '#slide_brand'
  }
  function init(){
    if(jQuery(poshecommerce.brandSliderEle.slideBrand).length){
      jQuery(poshecommerce.brandSliderEle.slideBrand).slick({
    	dots: false,
    	infinite: true,
        arrows: true,
      	nextArrow: '<div class="slick-next"><i class="icon fa fa-chevron-right"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon fa fa-chevron-left"></i></div>',
    	speed: 300,
    	slidesToShow: 6,
    	slidesToScroll: 1,
    	responsive: [
          {
              breakpoint: 1024,
              settings: {
                  slidesToShow: 5,
                  slidesToScroll: 1,
              }
          },
          {
              breakpoint:767,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 640,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
          }
		]
	 });

    }
  }
  return {
  	init: init,    
  }
}());

// Instagram Slider 
poshecommerce.Instagram = (function (){
  function sliderInit(){
    jQuery(".instafeed_carousel").slick({
   	 	dots: false,
   	 	infinite: true,
    	speed: 100,
      	arrows: true,
      	nextArrow: '<div class="slick-next"><i class="icon fa fa-chevron-right"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon fa fa-chevron-left"></i></div>',
    	slidesToShow: poshecommerce.instagram_grid,
    	slidesToScroll: 1,
        responsive: [
      {
          breakpoint:1200,
          settings: {
              slidesToShow: 5,
              slidesToScroll: 1
          }
      },
      {
          breakpoint:1024,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 1
          }
      },
      {
          breakpoint:767,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 640,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
      }
	]
	});
  } 
  return {
  	sliderInit: sliderInit,    
  }
  
}());



poshecommerce.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = poshecommerce.mapKey ? poshecommerce.mapKey : '';

  function Map(container) {
    this.$container = jQuery(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          jQuery.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    jQuery.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = jQuery.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', jQuery.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = poshecommerce.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = poshecommerce.strings.addressQueryLimit;
              break;
            default:
              errorMessage = poshecommerce.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  jQuery('.map-section').addClass('map-section--load-error');
  jQuery('.map-section__container').remove();
  jQuery('.map-section__link').remove();
  jQuery('.map-section__overlay').after('<div class="errors text-center">' + poshecommerce.strings.authError + '</div>');
}

/* eslint-disable no-new */

poshecommerce.tmp=1;
poshecommerce.Product = (function() {
 
  function Product(container) {
  
    var $container = this.$container = jQuery(container);
    
    var dealsection = $container.attr('data-section-type');
  
    var sectionId = $container.attr('data-section-id');
	var windwidth = jQuery(window).width();
    //alert(windwidth);
    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '#FeaturedImage-' + sectionId,
      productImageWrap: '#FeaturedImageZoom-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      qtyButton:'.button',
      swatchRadio : '.swatch :radio'
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the poshecommerce Editor
    
    if (!jQuery('#ProductJson-' + sectionId).html()) {
      return;
    }
    
    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);


    this.settings.zoomEnabled = jQuery(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    if(!jQuery('#shopify-section-quick-shop').length ){
      if(dealsection != 'dealofday-section'){
    		this.settings.imageSize = poshecommerce.Images.imageSize(jQuery(this.selectors.productFeaturedImage).attr('src'));
      }
    }
    if (this.settings.zoomEnabled) {
      this.settings.imageZoomSize = poshecommerce.Images.imageSize(jQuery(this.selectors.productImageWrap).data('zoom'));
    }

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
    
    if(poshecommerce.tmp==1){
    	this._updateQty();
     
      poshecommerce.tmp=2;
    }
    this._colorSwatch();    
    
    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    poshecommerce.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      poshecommerce.productStrings = poshecommerce.productStrings || {};
      jQuery.extend(poshecommerce.strings, poshecommerce.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;
      
      //below line is add to initialize Product slider on Desktop also.
      //if (/Android|BlackBerry|iPhone|iPad|iPod|webOS/i.test(navigator.userAgent) === false) {//}
      self._initThumbnailSlider();// not a mobile device
      //ends here
      
      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if (jQuery(self.selectors.productThumbImages).length > 3) {
            self._destroyThumbnailSlider(); //very important for footer navigation issue due to slider in mobile
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom(jQuery(self.selectors.productImageWrap));
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {            
            _enableZoom(jQuery(self.selectors.productImageWrap));
          }
        }
      });
    },

    _initVariants: function() {
      
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new poshecommerce.Variants(options);

      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
    },

    _initImageSwitch: function() {
      
      if (!jQuery(this.selectors.productThumbImages).length) {
        
        return;
      }

      var self = this;

      jQuery(this.selectors.productThumbImages).on('click', function(evt) {
       
        evt.preventDefault();
        var $el = jQuery(this);
        var imageSrc = $el.attr('href');
        var zoomSrc = $el.data('zoom');

        self._switchImage(imageSrc, zoomSrc);
        self._setActiveThumbnail(imageSrc);
      });
    },
    _updateQty: function(){
      
      jQuery(this.selectors.qtyButton).on('click', function(evt) {
      
        var oldValue = jQuery(this).siblings("#pro_quantity").val();
      
        var newVal = 1;
        if (jQuery(this).text() == "+") {
            newVal = parseInt(oldValue) + 1;
        } else if (oldValue > 1) {
            newVal = parseInt(oldValue) - 1;
        }
        
        jQuery(this).siblings("#pro_quantity").val(newVal);
        
	
      });
    },
    _colorSwatch: function(){
      
      /*----- Color Swatches ---*/

      jQuery(this.selectors.swatchRadio).change(function() {
       
    	var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    	var optionValue = jQuery(this).val();
    	jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
   		Currency.convertAll(Currency.default_curr, Currency.currentCurrency, 'span.money', Currency.format);
      });
      
      /*----- End ---*/
    },
    _setActiveThumbnail: function(src) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof src === 'undefined') {
        src = jQuery(this.selectors.productFeaturedImage).attr('src');
      }

      // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
      var $thumbnail = jQuery(this.selectors.productThumbImages + '[href="' + src + '"]');
      jQuery(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function(image, zoomImage) {
      jQuery(this.selectors.productFeaturedImage).attr('src', image);

      // destroy image zooming if enabled
      if (this.settings.zoomEnabled) {
        _destroyZoom(jQuery(this.selectors.productImageWrap));
      }

      if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
        jQuery(this.selectors.productImageWrap).data('zoom', zoomImage);
        _enableZoom(jQuery(this.selectors.productImageWrap));
      }
    },

    _initThumbnailSlider: function() {
      var vertical = false;
      if(poshecommerce.imageSliderPosition == "vertical"){
         vertical = true;
      }
     
      var options = {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        vertical: vertical,
        
		//verticalSwiping: true,
        //adaptiveHeight: true,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        // the magic
        responsive: [{

            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              
            }

          }, {

            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              
            }

          }, {

            breakpoint: 300,
            settings: "unslick" // destroys slick

          }]
      };

      //alert(">>"+this.selectors.productThumbs);
      jQuery(this.selectors.productThumbs).slick(options);
     
      this.settings.sliderActive = true;
      //console.log("dfdfgdf");
      //jQuery(window).resize();
      //jQuery(this.selectors.productThumbs).slick('prev');
    },

    _destroyThumbnailSlider: function() {
      jQuery(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        jQuery(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');

        if (variant.available) {
          jQuery(this.selectors.addToCart).prop('disabled', false);
          jQuery(this.selectors.addToCartText).text(poshecommerce.strings.addToCart);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          jQuery(this.selectors.addToCart).prop('disabled', true);
          jQuery(this.selectors.addToCartText).text(poshecommerce.strings.soldOut);
        }
      } else {
        jQuery(this.selectors.addToCart).prop('disabled', true);
        jQuery(this.selectors.addToCartText).text(poshecommerce.strings.unavailable);
        jQuery(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false');
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = poshecommerce.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var zoomSizedImgUrl;

      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = poshecommerce.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      }

      this._switchImage(sizedImgUrl, zoomSizedImgUrl);
      this._setActiveThumbnail(sizedImgUrl);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      jQuery(this.selectors.originalPrice).html(poshecommerce.Currency.formatMoney(variant.price, poshecommerce.moneyFormat));

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        jQuery(this.selectors.comparePrice)
          .html(poshecommerce.Currency.formatMoney(variant.compare_at_price, poshecommerce.moneyFormat))
          .removeClass('hide');

        jQuery(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);

        jQuery(this.selectors.saleLabel).removeClass('hide');
      } else {
        jQuery(this.selectors.comparePrice).addClass('hide');
        jQuery(this.selectors.saleLabel).addClass('hide');
        jQuery(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el) {
    var zoomUrl = $el.data('zoom');
    $el.zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom($el) {
    $el.trigger('zoom.destroy');
  }

  return Product;
})();


poshecommerce.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 998px)',
    mediaQueryMediumUp: 'screen and (min-width: 999px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  function Quotes(container) {
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = jQuery(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = jQuery.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
		
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      jQuery(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = jQuery('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      jQuery(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = jQuery(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

poshecommerce.slideshows = {};

poshecommerce.SlideshowSection = (function() {
  function SlideshowSection(container) {
    
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    jQuery('.slideshow__video', slideshow).each(function() {
      var $el = jQuery(this);
      poshecommerce.SlideshowVideo.init($el);
      poshecommerce.SlideshowVideo.loadVideo($el.attr('id'));
    });

    poshecommerce.slideshows[slideshow] = new poshecommerce.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

poshecommerce.SlideshowSection.prototype = _.assignIn({}, poshecommerce.SlideshowSection.prototype, {
  onUnload: function() {
    delete poshecommerce.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = jQuery(this.slideshow);

    // Ignore the cloned version
    var $slide = jQuery('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    jQuery(this.slideshow).slick('slickPlay');
  }
});

poshecommerce.prcarousel = {};

poshecommerce.prodcarouselSection = (function() {
  function prodcarouselSection(container) {
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    var prcarousel = this.bestseller = '#prcarousel-' + sectionId;
    
    if(sectionId == 'featured-collections' || sectionId == 1491200979376 || sectionId == 456789456654777 || sectionId == 456789456654564){
    
     var className = $container.attr('class');
     var slide=4;
     var scroll = 1;
     var str = className;
     if (str.indexOf('slide_') > -1) {
      	var n = str.search("slide_");
       	slide = str.substr(n+6, 1);
       	scroll = str.substr(n+8, 1);
     }
        
     jQuery(prcarousel).slick({
        dots: false,
        infinite: false,
        speed: 300,
        cssEase: 'linear',
        arrows: true,
        nextArrow: '<div class="slick-next"><i class="icon '+poshecommerce.productArrowNext+'"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon '+poshecommerce.productArrowPrev+'"></i></div>',
        slidesToShow: parseInt(slide),
        slidesToScroll: parseInt(scroll),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: parseInt(scroll),
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow:2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }else {
     
     var className = $container.attr('class');
     var slide=4;
     var scroll = 1;
     var str = className;
     if (str.indexOf('slide_') > -1) {
      	var n = str.search("slide_");
       	slide = str.substr(n+6, 1);
       	scroll = str.substr(n+8, 1);
     }
      
     
      jQuery(prcarousel).slick({
        dots: false,
        infinite: false,
        speed: 300,
        arrows: true,
        nextArrow: '<div class="slick-next"><i class="icon '+poshecommerce.productArrowNext+'"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon '+poshecommerce.productArrowPrev+'"></i></div>',
        cssEase: 'linear',
        slidesToShow: parseInt(slide),
        slidesToScroll: parseInt(scroll),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: parseInt(scroll),
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow:2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }

  return prodcarouselSection;
})();

poshecommerce.bestseller = {};
poshecommerce.collectionslider = {};
poshecommerce.productbannerslider = {};
poshecommerce.productdealday = {};
poshecommerce.bannerslider = {};


poshecommerce.bestsellerSection = (function() {
  function bestsellerSection(container) {
   
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    var bestseller = this.bestseller = '#bestseller-' + sectionId;
    var className='';
    var slide='';
    var scroll='';
    var className = $container.attr('class');
    
    var slideval = className.split("_");
   
    var n = className.lastIndexOf('_');
	var scroll = className.substring(n + 1);
    
    var slidenext = jQuery(bestseller).siblings('.right-side-arrow').find('.slick-next');
    var slideprev = jQuery(bestseller).siblings('.right-side-arrow').find('.slick-prev');
	
    var slide = slideval[1];
    slideval = [];
    if(!jQuery(bestseller).closest('#bestseller-style-3').length){
    
    jQuery(bestseller).slick({
        dots: false,
        infinite: false,
      	arrows: true,
        nextArrow: '<div class="slick-next"><i class="icon '+poshecommerce.productArrowNext+'"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon '+poshecommerce.productArrowPrev+'"></i></div>',
        speed: 300,
        cssEase: 'linear',
        slidesToShow: parseInt(slide),
        slidesToScroll: parseInt(scroll),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll:parseInt(scroll),
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]
     });
    
    }
    else{
      jQuery(bestseller).slick({
        dots: false,
        infinite: false,
        cssEase: 'linear',
      	arrows: false,
        //nextArrow: '<div class="slick-next"><i class="icon fas fa-chevron-right"></i></div>',
  		//prevArrow: '<div class="slick-prev"><i class="icon fas fa-chevron-left"></i></div>',
        speed: 300,
        slidesToShow: parseInt(slide),
        slidesToScroll: parseInt(scroll),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll:parseInt(scroll),
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]
     });
    }
    /*jQuery(document).on('click',slidenext,function(event) {
      jQuery(bestseller).slick('slickNext');
    });
    jQuery(document).on('click',slideprev,function(event) {
      	 jQuery(bestseller).slick('slickPrev');
    });*/
      slidenext.bind( "click", function( event ) {
        jQuery(bestseller).slick('slickNext');
      });
      slideprev.bind( "click", function( event ) {
        jQuery(bestseller).slick('slickPrev');
      });
  }
  
  // alignProductGridActions('.grid__item');
  
  	

  return bestsellerSection;
})();

poshecommerce.collectionlistSection = (function() {
 
  function collectionlistSection(container) {
    
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    
    var collectionlist = this.collectionslider = '#collectionlist-' + sectionId;
	
    var className = $container.attr('class');
    
    
   
    var n = className.lastIndexOf('_');
	var slide = className.substring(n + 1);
    
   
    jQuery(collectionlist).slick({
       
      	dots: false,
        infinite: true,
        speed: 300,
      	arrows: true,
        nextArrow: '<div class="slick-next"><i class="icon '+poshecommerce.productArrowNext+'"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon '+poshecommerce.productArrowPrev+'"></i></div>',
        
        slidesToShow: parseInt(slide),
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
     });
    
  }
  
  // alignProductGridActions('.grid__item');
  
  	

  return collectionlistSection;
})();
poshecommerce.productGridCounter = (function(){
  function init(){
    if(jQuery('.productCounter').length){
      jQuery( "div[id^=countdownProductGrid]" ).each(function( index ) {
        
        
        var enddate =  jQuery(this).siblings('#endDate').text();

        
        var slidetimezone =  moment.tz(enddate+" 00:00", poshecommerce.timezone).toDate();
        var m1 = "";
        var m2 = "";
        var m3 = "";
        var m4 = "";
        
        
        jQuery(this).countdown(slidetimezone, function(event) {
          if(event.strftime('%D') != 0 || event.strftime('%H') != 0 || event.strftime('%M') != 0 || event.strftime('%S')!=0 ){
          jQuery(this).find('.countDays .digit').text(event.strftime('%D'));
           jQuery(this).find('.countDays .countdot').text(event.strftime(':'));
          jQuery(this).find('.countHours .digit').text(event.strftime('%H'));
           jQuery(this).find('.countHours .countdot').text(event.strftime(':'));
          jQuery(this).find('.countMinutes .digit').text(event.strftime('%M'));
           jQuery(this).find('.countMinutes .countdot').text(event.strftime(':'));
          jQuery(this).find('.countSeconds .digit').text(event.strftime('%S'));
          }
          else{
            jQuery(this).hide();
          }
		
          
        });
       
        
      });
    }
  }
  return {
  	init: init,    
  }
}());

poshecommerce.quickShop = (function(){
  function init(){
    jQuery(document).on('click', '.quickShopbtn', function(e) {
      //console.log("QUICKSHOP");
      	e.preventDefault();
     	var url = jQuery(this).attr('data-ajax');
        var id = jQuery(this).attr('id');
        var productGrid = jQuery(this).closest('.btnHover').siblings('#productshop-'+id);
		//console.log(jQuery(this).closest('.details-right').parent('.products-details'))
      	if(jQuery('.product-hover-effect-3').length){
             //productGrid = jQuery(this).closest('.details-right').parent('.products-details').siblings('.proHover').find('#productshop-'+id);
			
      	}
        jQuery.ajax({
               url: url,
               dataType: "html",
               type: "GET",
               success: function(t) {
                 productGrid.find('.quickDetails').append(t);
                 	var sections = new poshecommerce.Sections();
                   sections.register('quick-shop', poshecommerce.Product);
                
                   productGrid.addClass('showQuickShop');
                   productGrid.show();
                   if(jQuery('.list-view-items').length){
                   	jQuery('#productshop-'+id).find('.quickDetails').append(t);
                   	jQuery('#productshop-'+id).addClass('showQuickShop');
                   	jQuery('#productshop-'+id).show();
                   }
                 	
                   //jQuery(document).on('click', '.posh-quick-shop #closeQuickShop', function(e) {
                   	 jQuery(".posh-quick-shop .closeQuickShop").click(function(){	
                     	jQuery(this).closest('.posh-quick-shop').hide();
                   		jQuery(this).siblings('.quickDetails').empty();
                   		jQuery(this).closest('.posh-quick-shop').removeClass('showQuickShop');
                   });
               },
               error: function() {
                   console.log("Quick Shop error");
               }
        });
    });
 
  }
  return {
  	init: init,    
  }
}());


poshecommerce.dealofdaySection = (function() {
 
  function dealofdaySection(container) {
    
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    
    var dealBanner = this.productdealday = '#countdown-' + sectionId;
	
    var className = jQuery(dealBanner).attr('class');
   
    var part = className.split(" ");
    var timezone = part[1];
    
   
    var enddate =  jQuery(dealBanner).siblings('#endDate').text();
    
   	
    var n = timezone.lastIndexOf('-');
	var slide = timezone.substring(n + 1);
    var slidetimezone =  moment.tz(enddate+" 00:00", slide).toDate();
    
       jQuery(dealBanner).countdown(slidetimezone, function(event) {
          if(event.strftime('%D') != 0 || event.strftime('%H') != 0 || event.strftime('%M') != 0 || event.strftime('%S')!=0 ){
          	jQuery(dealBanner).find('.countDays .digit').text(event.strftime('%D'));
           	jQuery(dealBanner).find('.countDays .countdot').text(event.strftime(':'));
          	jQuery(dealBanner).find('.countHours .digit').text(event.strftime('%H'));
           	jQuery(dealBanner).find('.countHours .countdot').text(event.strftime(':'));
          	jQuery(dealBanner).find('.countMinutes .digit').text(event.strftime('%M'));
           	jQuery(dealBanner).find('.countMinutes .countdot').text(event.strftime(':'));
          	jQuery(dealBanner).find('.countSeconds .digit').text(event.strftime('%S'));
          }
          else{
            jQuery(dealBanner).hide();
          }
        });
  }
  
  // alignProductGridActions('.grid__item');
  
  	

  return dealofdaySection;
})();

/*poshecommerce.bannerSwatchSection = (function() {
  function bannerSwatchSection(container) {
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    var productbanner = this.productbannerslider = '#swatchBanner-' + sectionId;
	document.querySelectorAll(productbanner).forEach(function (element, index) {
      
      var sections = new poshecommerce.Sections();
     
      //sections.register('swatchBanner-' + sectionId, poshecommerce.Product);
    });
  }
 return bannerSwatchSection;
})();*/
poshecommerce.productImagebannerSection =  (function() {
  
  function productImagebannerSection(container) {
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    var imagebanner = this.productbannerslider = '#productImagebanner-' + sectionId;
    
    jQuery(imagebanner).slick({

            dots: false,
            infinite: false,
            speed: 300,
     		vertical: true,
            arrows: true,      		
            nextArrow: '<div class="slick-next"><i class="icon '+poshecommerce.productArrowNext+'"></i></div>',
            prevArrow: '<div class="slick-prev"><i class="icon '+poshecommerce.productArrowPrev+'"></i></div>',

            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                }
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              }
            ]
         });
    	jQuery(imagebanner).find('.slick-track').css('height','auto');
      }
   return productImagebannerSection;
})();
poshecommerce.productbannerSection = (function() {
 
  function productbannerSection(container) {
   
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    
    var productbanner = this.productbannerslider = '#productbanner-' + sectionId;
    
	var counter = this.productbannerslider = '#countdown-' + sectionId;

    var className = $container.attr('class');
    
    	var counter1 = this.productbannerslider = 'countdown-' + sectionId;

      
    jQuery(productbanner).slick({
       
      	dots: false,
        infinite: false,
        speed: 300,
      	arrows: true,
        nextArrow: '<div class="slick-next"><i class="icon '+poshecommerce.productArrowNext+'"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon '+poshecommerce.productArrowPrev+'"></i></div>',
        
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
     });
    
   // document.querySelectorAll(counter).forEach(function (element, index) {
    jQuery( "div[id^="+counter1+"]" ).each(function( index ) { 
   	 var enddate = jQuery(this).siblings('#endDate').text();
        
       var slidetimezone =  moment.tz(enddate+" 00:00",  poshecommerce.timezone).toDate();
       

      
      jQuery(this).countdown(slidetimezone, function(event) {
          if(event.strftime('%D') != 0 || event.strftime('%H') != 0 || event.strftime('%M') != 0 || event.strftime('%S')!=0 ){
          jQuery(this).find('.countDays .digit').text(event.strftime('%D'));
           jQuery(this).find('.countDays .countdot').text(event.strftime(':'));
          jQuery(this).find('.countHours .digit').text(event.strftime('%H'));
           jQuery(this).find('.countHours .countdot').text(event.strftime(':'));
          jQuery(this).find('.countMinutes .digit').text(event.strftime('%M'));
           jQuery(this).find('.countMinutes .countdot').text(event.strftime(':'));
          jQuery(this).find('.countSeconds .digit').text(event.strftime('%S'));
          }
          else{
            jQuery(this).hide();
          }
          
        });
    });
    
    
    
  }
  // alignProductGridActions('.grid__item');
  return productbannerSection;
})();

poshecommerce.bannerSliderSection = (function() {
 
  function bannerSliderSection(container) {
    
    var $container = this.$container = jQuery(container);
    var sectionId = $container.attr('data-section-id');
    
    var bannersliders = this.bannerslider = '#bannerSlider-' + sectionId;
   
    jQuery(bannersliders).slick({
       
      	dots: false,
        infinite: true,
        speed: 300,
      	arrows: true,
        nextArrow: '<div class="slick-next"><i class="icon '+poshecommerce.productArrowNext+'"></i></div>',
  		prevArrow: '<div class="slick-prev"><i class="icon '+poshecommerce.productArrowPrev+'"></i></div>',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
     });
    
    
  }
  
  // alignProductGridActions('.grid__item');
  return bannerSliderSection;
})();

// Responsive Tabs
poshecommerce.responsiveTabs = (function(jQuery){
  responsiveTabsEle = {
    $responsiveTabs 	 :  jQuery('#responsiveTabs'),
    $responsiveTabsClick :  jQuery('#responsiveTabs .r-tabs-anchor'),
    $responsiveTabsNext  :  jQuery('#responsiveTabs .slick-next')
  }
  function init(){
    if(responsiveTabsEle.$responsiveTabs.length){
    
     	responsiveTabsEle.$responsiveTabs.responsiveTabs({
      		//startCollapsed: 'accordion',
      		//active: 1,
     	});
    
     jQuery('#responsiveTabs .r-tabs-anchor').click(function() {
      	 //jQuery( "#responsiveTabs .slick-next" ).trigger( "click" );
       	 jQuery( "#responsiveTabs .slick-prev" ).trigger( "click" );
  		 setTimeout(function(){ 
       	  	alignProductGridActionsHome('.r-tabs-state-active');
         }, 500);	
   
     });
      
     jQuery(window).on('resize', function(){
       var win = jQuery(this); //this = window
       if (win.width() >= 1200) {
        jQuery('#responsiveTabs ul li:first').find('.r-tabs-anchor').trigger('click');
       }
     });
    
    }
  }
  function productTabs(){
    if(jQuery('.productsTabs').length){
       jQuery('#responsiveTabs').responsiveTabs({
           startCollapsed: 'accordion'
       });
    }
  }
  return {
    init: init,
    productTabs : productTabs,
  }
}(jQuery));
// End Responsive Tabs 


// Parallax Banner

poshecommerce.parallaxImage = (function(){
  function init(){
    resize_all_parallax();
    jQuery(window).on('resize', function(){
		resize_all_parallax();
	});
  }
  function resize_all_parallax() {
        var div_id_opp = 'medium-up--one-half'; /* opposite div class */
		var div_id = 'img_parallax'; /* the ID of the div that you're resizing */
		var img_w = 960; /* the width of your image, in pixels */
		var img_h = 960; /* the height of your image, in pixels */
		resize_parallax(div_id,div_id_opp, img_w,img_h);
	}
	/* this resizes the parallax image down to an appropriate size for the viewport */
	function resize_parallax(div_id,div_id_opp,img_w,img_h) {
		var div = jQuery('.' + div_id);
        var div_id_opp = jQuery('.' + div_id_opp);
		var div_id_opp_width = div_id_opp.width();
        var divwidth = div.width();
     // console.log("divwidth::" + divwidth + "window.width ::" + jQuery(window).width());
		if (divwidth < 769) { var pct = (img_h/img_w) * 112; } /* show full image, plus a little padding, if on static mobile view */
		else { var pct = 90; } /* this is the HEIGHT as percentage of the current div WIDTH. you can change it to show more (or less) of your image */
		var newheight = Math.round(divwidth * (pct/100));
        var newheight_opp = div_id_opp.height();
		newheight = newheight  + 'px';
        newheight_opp = 719; //newheight_opp + 'px';
		div.height(newheight_opp);
      
      if(newheight_opp > divwidth){
        newheight_opp = newheight_opp;
      }else{
        if(divwidth > 960){
        	newheight_opp = divwidth;  
        }else{
         newheight_opp = 960;
        }
    	
        div.css("height",'960px');
      }
      if(div_id_opp_width > newheight_opp){
      	//newheight_opp = 960;
         
      }
        div.css("background-size", newheight_opp + 'px');
      
      var windowwidth = jQuery(window).width();
//    
      var flagfortextheight = true;
      
      if ( jQuery(".page-container").hasClass("boxed-layout") ) {
      //	console.log("FOUND");
        if(windowwidth > 1300){
          
          if(windowwidth > 1300 && windowwidth < 1600){
              newheight_opp = 719;
              div.height(newheight_opp);
              jQuery(".parallax_img_left").css("background-size","50%");
              jQuery(".parallax_img_right").css("background-size","50%");
             // console.log("FOUND BACKGROUND SIZE");
          }
           if(windowwidth >= 1600){
                newheight_opp = 960;
            div.height(newheight_opp);
            jQuery(".parallax_img_left").css("background-size","50%");
            jQuery(".parallax_img_right").css("background-size","50%");
          //  console.log("FOUND BACKGROUND SIZE");
             flagfortextheight = false;
          }
          windowwidth = 1200;
        }
      }
      if(windowwidth > 768 && windowwidth < 1025 ){
        div.css("height",'719px');
	  }
      
      if(windowwidth < 1000 ){
        
        jQuery(".parallax-image").css("display","none");
        jQuery(".feature-row__text--right").css("width","100%");
        jQuery(".feature-row__text--left").css("width","100%");
        jQuery( ".parallax-text-right-side" ).each(function( index ) {
          jQuery(".parallax-text-right-side").eq(index).css("background-image",  jQuery(".parallax_img_right").eq(index).css("background-image"));
          jQuery(".parallax-text-left-side").eq(index).css("background-image",   jQuery(".parallax_img_left").eq(index).css("background-image"));
		});
        jQuery(".parallax-text-right-side").css("background-size",  "cover");
        jQuery(".parallax-text-left-side").css("background-size",  "cover");
      /*  jQuery(".parallax_img_left").css("background-attachment","scroll");
        jQuery(".parallax_img_right").css("background-attachment","scroll");*/
        jQuery(".feature-row__text").css("min-height","auto");
        div_id_opp.css("height",'');
        
     
      }else{
      	
        jQuery(".parallax-image").css("display","");
        jQuery(".feature-row__text--right").css("width","50%");
        jQuery(".feature-row__text--left").css("width","50%");
        jQuery(".parallax-text-right-side").css("background-image",  "");
        jQuery(".parallax-text-left-side").css("background-image",   "");
       /* jQuery(".parallax_img_left").css("background-attachment","fixed");
        jQuery(".parallax_img_right").css("background-attachment","fixed");*/
        //jQuery(".feature-row__text").css("min-height","719"); 
        if(flagfortextheight){
          	if(windowwidth > 1436 ){
          	     	jQuery(".feature-row__text").css("height","960");
            }else{
                 	jQuery(".feature-row__text").css("height","719");
            }
        }else{
        	jQuery(".feature-row__text").css("height","960");
        }
      }   
	}
  return {
    init: init
  }
}());

// End
poshecommerce.mobileSideNavDrawer = (function(jQuery) {
  poshecommerce.mobileSideNavDrawerElement = {
	    $html                    : jQuery('html'),
	    $body                    : jQuery('body'),
	    $mobileSideNav     		 : jQuery('#mobileSideNav'),
    	$AccessibleNav           : jQuery('#AccessibleNav'),
    	$Accessiblesidenav  	 : jQuery('#AccessibleNav.sidenav'),
    	$navOuter 				 : jQuery('.nav-outer'),
        $overlay                 : '#overlay',
    	$closeSideNav            : jQuery('#closeSideNav'),
    	$menuDrawer              : jQuery('#header_menu')
  };
  function init() {
    jQuery( "#header_menu" ).insertAfter( "#PageContainer" );
      		initmobileSideNavDrawer(),mobileSideNavDrawerClick(),closemobileSideNavDrawer();
     	}
  function mobileSideNavDrawerClick(){
          jQuery(poshecommerce.mobileSideNavDrawerElement.$mobileSideNav).bind("click", function(e) {
          
            jQuery.drawer_menu.toggle(poshecommerce.mobileSideNavDrawerElement.$menuDrawer);
          	
            jQuery('#admin_bar_iframe').css('right',0);
            jQuery("#back-to-top1").css('right','3%');
            jQuery(poshecommerce.cartDrawerElement.$overlay).css('display','block');
          });
  		}
  function initmobileSideNavDrawer(){
    if(jQuery(poshecommerce.mobileSideNavDrawerElement.$menuDrawer).length){
     
          jQuery(poshecommerce.mobileSideNavDrawerElement.$body).addClass(poshecommerce.cartDrawerElement.$drawerMenuBody);
          jQuery(poshecommerce.mobileSideNavDrawerElement.$body).addClass(poshecommerce.cartDrawerElement.$drawerMenuPage);
      	  if(jQuery('#header_5').length){
            //setTimeout(function(){ 
              jQuery(poshecommerce.mobileSideNavDrawerElement.$menuDrawer).drawer_menu({
                speed : 200,
                child_speed : 200,
                cssAnimation : true,
                resizePer : true,
                beforeOpen : function(){

                   jQuery(document).scrollTop(0);
                   jQuery(poshecommerce.mobileSideNavDrawerElement.$overlay).css('display','block');
                },
              });
           // }, 3000);
          }
      	  else{
           //setTimeout(function(){ 
            jQuery(poshecommerce.mobileSideNavDrawerElement.$menuDrawer).drawer_menu({
                speed : 200,
                child_speed : 200,
                side  : 'left',
                cssAnimation : true,
                resizePer : true,
                beforeOpen : function(){

                   jQuery(document).scrollTop(0);
                   jQuery(poshecommerce.mobileSideNavDrawerElement.$overlay).css('display','block');
                },
              });
           // }, 3000);
          }
      	}
  }
  function closemobileSideNavDrawer(){
          jQuery(document).bind("click touchend", function(e) {
              var target = e.target; 
                if(!jQuery(e.target).closest(poshecommerce.mobileSideNavDrawerElement.$menuDrawer).length && !jQuery(e.target).closest("#shopify-section-header").length && !jQuery(e.target).closest(poshecommerce.cartDrawerElement.$cartDrawer).length) {
                  jQuery(poshecommerce.cartDrawerElement.$overlay).css('display','none');
                  jQuery(poshecommerce.cartDrawerElement.$menuDrawer).drawer_menu("close");
                  jQuery('#admin_bar_iframe').css('right',0);
                  jQuery("#back-to-top1").css('right','3%');
                  //setTimeout(function() { 
                          jQuery(poshecommerce.cartDrawerElement.$header).removeAttr('style');    
                          jQuery(poshecommerce.cartDrawerElement.$quickView).css({'left':'','transform':''}); 
                  		  jQuery("#SearchDrawer").removeAttr('style');  
                          jQuery(poshecommerce.cartDrawerElement.$PageContainer).css({'left':'','transform':''});
                          jQuery(poshecommerce.cartDrawerElement.$successDrawer).css({'left':'','transform':''});
                          jQuery(poshecommerce.cartDrawerElement.$modalOverly).css({'left':'','transform':''});
                          jQuery(poshecommerce.cartDrawerElement.$loadingBox).css({'left':'','transform':''});
                  //}, 500);
              }
			});
  		}
          return {
    		init: init,
        
   
  		}
}(jQuery));

// Mobile Side NavigationMenu
poshecommerce.mobileSideNav = function(){
  if(jQuery('#header_menu').length){
    poshecommerce.mobileSideNavDrawer.init();
    return;
  }
 
  poshecommerce.mobileSideNavElement = {
	    $html                    : jQuery('html'),
	    $body                    : jQuery('body'),
	    $mobileSideNav     		 : jQuery('#mobileSideNav'),
    	$AccessibleNav           : jQuery('#AccessibleNav'),
    	$Accessiblesidenav  	 : jQuery('#AccessibleNav.sidenav'),
    	$navOuter 				 : jQuery('.nav-outer'),
    	$closeSideNav            : jQuery('#closeSideNav')
  };
  
  poshecommerce.mobileSideNavElement.$mobileSideNav.bind("click", function(e) {
    if (jQuery(window).width() > 999 ) {
      
      poshecommerce.mobileSideNavElement.$AccessibleNav.removeClass('medium-down--hide');
      poshecommerce.mobileSideNavElement.$AccessibleNav.addClass('sidenav');
      poshecommerce.mobileSideNavElement.$AccessibleNav.css("width","350px");
      jQuery(".nav-outer").addClass("overlay-menu");       
     
      poshecommerce.mobileSideNavElement.$body.css('overflow','hidden');
      poshecommerce.mobileSideNavElement.$body.css('height','100%');
      poshecommerce.mobileSideNavElement.$html.css('overflow','hidden');                                             
      poshecommerce.mobileSideNavElement.$html.css('height','100%');

  	}
    else {
      
      jQuery('#AccessibleNav').removeClass('medium-down--hide');
      jQuery('#AccessibleNav').addClass('sidenav');
      jQuery('#AccessibleNav').css("width","300px");
      //setTimeout(function() {
          	jQuery(".nav-outer").addClass("overlay-menu");      
        	poshecommerce.mobileSideNavElement.$body.css('overflow','hidden');
    		poshecommerce.mobileSideNavElement.$body.css('height','100%');
            poshecommerce.mobileSideNavElement.$html.css('overflow','hidden');                                             
            poshecommerce.mobileSideNavElement.$html.css('height','100%');
        	//poshecommerce.mobileSideNavElement.$body.css('pointer-events','none');
      //}, 250);
    }
  });
  poshecommerce.mobileSideNavElement.$closeSideNav.bind("click", function(e) {
    jQuery("#AccessibleNav.sidenav").css("width","0");
  	jQuery(".nav-outer").removeClass("overlay-menu");
    
  	poshecommerce.mobileSideNavElement.$body.css('overflow','');
    poshecommerce.mobileSideNavElement.$body.css('height','auto');
    poshecommerce.mobileSideNavElement.$html.css('overflow','');
    poshecommerce.mobileSideNavElement.$html.css('height','auto');
    e.preventDefault();
  });
  jQuery(document).bind("click", function(e) {
    var target = e.target; 
    if(!jQuery(e.target).closest('.nav-outer').length && !jQuery(e.target).closest("#shopify-section-header").length) {
    	jQuery("#AccessibleNav").removeAttr("style");
        jQuery(".nav-outer").removeClass("overlay-menu");
        poshecommerce.mobileSideNavElement.$body.css('overflow','');
    	poshecommerce.mobileSideNavElement.$body.css('height','auto');
    	poshecommerce.mobileSideNavElement.$html.css('overflow','');
    	poshecommerce.mobileSideNavElement.$html.css('height','auto');	
    }
    var $navOuter = jQuery('.nav-outer');
    var $t = e.target;  
    if (($navOuter).is($t) || jQuery('.sidenav').is($t)) {             
        var AccessibleNav = jQuery("#AccessibleNav");
        if(AccessibleNav != null ){
           jQuery("#AccessibleNav").removeAttr("style");
           jQuery(".nav-outer").removeClass("overlay-menu");
          
           poshecommerce.mobileSideNavElement.$body.css('overflow','');
    	   poshecommerce.mobileSideNavElement.$body.css('height','auto');
    	   poshecommerce.mobileSideNavElement.$html.css('overflow','');
    	   poshecommerce.mobileSideNavElement.$html.css('height','auto');	
        }
    } 
  });
  jQuery(window).bind('resize', function() {
    jQuery("#AccessibleNav").removeAttr("style");
  });

};

// End Mobile Side NavigationMenu

// Test Search 

poshecommerce.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-header__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!jQuery(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    jQuery(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        jQuery(selectors.searchHeader).toggleClass(classes.focus);
      });

    jQuery(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = jQuery(selectors.siteHeader).outerHeight();
      var searchOffset = jQuery(selectors.siteHeader).offset().top - searchHeight;
     
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    jQuery('#PageContainer').addClass('drawer-page-content');
    jQuery('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false');

    poshecommerce.SearchDrawer = new poshecommerce.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus
    });
  }

  function searchDrawerFocus() {
    searchFocus(jQuery(selectors.searchDrawerInput));
    if (jQuery(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      //poshecommerce.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    jQuery(selectors.searchSubmit).on('click', function(evt) {
      var $el = jQuery(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }
  return {
    init: init
  };
})();
poshecommerce.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: jQuery('html').add('body'),
      $page: jQuery('#PageContainer')
    };

    this.config = jQuery.extend(defaults, options);
    this.position = position;

    this.$drawer = jQuery('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    jQuery(this.config.open).on('click', jQuery.proxy(this.open, this));
    this.$drawer.on('click touchend', this.config.close, jQuery.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.jQuerypage
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = jQuery(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    poshecommerce.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    jQuery(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    poshecommerce.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      jQuery.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );
	
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      jQuery.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

// End search


// Search Modal Module
poshecommerce.searchModal = function(){
  poshecommerce.searchElement = {
	    $html                    : jQuery('html'),
	    $body                    : jQuery('body'),
	    $searchModal     		 : jQuery('#searchModal'),
    	$searchInput 			 : jQuery('#qs'),
	    $searchButton     		 : jQuery('#searchButton'),
        $closeSearch             : jQuery('.closeSearch'),
    	$resultContainer         : jQuery('#resultContainer'),
    	$resultContainerUl       : jQuery('#resultContainer ul'),
    	$siteHeader              : jQuery('.site-header'),
    	$searchHeaderSubmit0 	 : jQuery('.search-header__submit:eq(0)'),
    	$qs0					 : jQuery('.qs:eq(0)'),
    	$qs                      : jQuery('.qs'),
    	$templateSearch          : 'template-search',
    	$srchQs					 : jQuery('.srch_qs'),
    	$srchPgSubmit			 : jQuery('.srch_pg_submit'),
        $srchPgNextlink          : jQuery('#srch_pg_nextlink'),
    	$srchPgPrevlink			 : jQuery('#srch_pg_prevlink')
    
  };
  var qs = gup('qs', window.location.href );
  if(qs != null){
	var SearchInput = jQuery('#SearchInput').val();
	var decoded_qs = decodeURIComponent(qs);
	jQuery('.qs').val(decoded_qs);
	jQuery('.srch_qs').val(decoded_qs);
	jQuery('.srch_term').html(decoded_qs);
  }
  function gup( name, url ) {
    
      if (!url) url = location.href;
      name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
      var regexS = "[\\?&]"+name+"=([^&#]*)";
      var regex = new RegExp( regexS );
      var results = regex.exec( url );
      return results == null ? null : results[1];
  }
  // On KeyPress // 
  poshecommerce.searchElement.$qs.bind("keyup", function(event) {
        var qs_str = jQuery(this).val();
        qs_str = jQuery.trim(qs_str);
        if(event.keyCode == 13) {
          if(qs_str != ""  ){
              var search_string = 'sku:'+qs_str+'*&q=body:'+qs_str+'*&q=title:'+qs_str+'*';
              jQuery(".hidden_query").val(search_string);
              var search_url = '/search?type=product&qs='+qs_str+'&q='+search_string;
              var decodedUri = decodeURIComponent(search_url);
              window.location.href= decodedUri; 

          } else {
            return false;
          }       
        } 
  });
  
  /*** OnEnter Key Press ***/
  poshecommerce.searchElement.$qs.bind("keypress", function(event) {
       var qs_str = jQuery(this).val();
       qs_str = jQuery.trim(qs_str);
       if(event.keyCode == 13 && qs_str == "" ) {
        event.preventDefault();
       }
  });
  if (poshecommerce.searchElement.$body.hasClass(poshecommerce.searchElement.$templateSearch)) {
    poshecommerce.searchElement.$srchQs.bind("keypress", function(event) {
        var qs_str = jQuery(this).val();
        qs_str = jQuery.trim(qs_str);

        if(event.keyCode == 13 && qs_str == "") {
         event.preventDefault();
        }
    });
    poshecommerce.searchElement.$srchPgSubmit.bind("click", function(event) {     
      var searchstr = jQuery('.srch_qs').val();
      searchstr = jQuery.trim(searchstr);
      if(searchstr != "") {
         var search_string = 'sku:'+searchstr+'*&q=body:'+searchstr+'*&q=title:'+searchstr+'*';
         var search_url = '/search?type=product&qs='+searchstr+'&q='+search_string;
         var decodedUri = decodeURIComponent(search_url);
         window.location.href= decodedUri;
      }else{
        return false;
      }
  	});
    poshecommerce.searchElement.$srchQs.bind("keyup", function(event) {     
      var qs_str = jQuery(this).val();
      qs_str = jQuery.trim(qs_str);
      if(event.keyCode == 13) {
        if(qs_str != ""){
            var search_string = 'sku:'+qs_str+'*&q=body:'+qs_str+'*&q=title:'+qs_str+'*';
            jQuery(".srch_hidden_query").val(search_string);
            var search_url = '/search?type=product&qs='+qs_str+'&q='+search_string;
            var decodedUri = decodeURIComponent(search_url);
            window.location.href= decodedUri; 
        } else {
          return false;
        }       
      } 
   });
      
	/*** Click on Next page on search result template ***/
	poshecommerce.searchElement.$srchPgNextlink.bind("click", function(event) { 
        var qs_str = jQuery(".srch_qs").val();
        qs_str = jQuery.trim(qs_str);
        var curr_pgno = jQuery("#srch_curr_pg").text(); 
        var next_pg = parseInt(curr_pgno)+1;
        var search_string = 'sku:'+qs_str+'*&q=body:'+qs_str+'*&q=title:'+qs_str+'*';
        var search_url = '/search?page='+next_pg+'&type=product&qs='+qs_str+'&q='+search_string;
        var decodedUri = decodeURIComponent(search_url);
        window.location.href= decodedUri; 
	});
    /*** Click on Previous page on search result template ***/
    poshecommerce.searchElement.$srchPgPrevlink.bind("click", function(event) {
      var qs_str = jQuery(".srch_qs").val();
      qs_str = jQuery.trim(qs_str);
      var curr_pgno = jQuery("#srch_curr_pg").text(); 
      var prev_pg = parseInt(curr_pgno)-1;
      var search_string = 'sku:'+qs_str+'*&q=body:'+qs_str+'*&q=title:'+qs_str+'*';
      var search_url = '/search?page='+prev_pg+'&type=product&qs='+qs_str+'&q='+search_string;
      var decodedUri = decodeURIComponent(search_url);
      window.location.href= decodedUri; 
    });
  }
  poshecommerce.searchElement.$searchHeaderSubmit0.bind("click", function(e) {
    
        var searchstr = poshecommerce.searchElement.$qs0.val();
        searchstr = jQuery.trim(searchstr);
        if(searchstr != ""){
          var search_string = 'sku:'+searchstr+'*&q=body:'+searchstr+'*&q=title:'+searchstr+'*';
          var search_url = '/search?type=product&qs='+searchstr+'&q='+search_string;
          var decodedUri = decodeURIComponent(search_url);
          window.location.href= decodedUri;
        }else{
          return false;
        }
  });
  

};
// End Search Modal

// Search AutoComplete

poshecommerce.searchAutoComplete = function(){
  
  var currentAjaxRequest = null;
  var searchForms = jQuery('.search').css('position','relative').each(function() {
  var input = jQuery(this).find('input[name="qs"]');
  var offSet = input.position().top + input.innerHeight();
  jQuery('<div id="resultContainer"></div>').appendTo(jQuery(this)).hide();
  jQuery('<div class="loadingBox-search" id="searchLoading"></div>').appendTo(jQuery(this).find('#resultContainer')).hide();  
  if(jQuery('.search-results ul').length == 0){
    	jQuery('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': '0' } ).appendTo(jQuery(this).find('#resultContainer')).hide();    
  }
  input.attr('autocomplete', 'off').bind('keyup change', function(e) {
      var term = jQuery(this).val();
      term = jQuery.trim(term);
      var form = jQuery(this).closest('form');
 
      var resultsList = form.find('.search-results');
      var resultdiv = form.find('#resultContainer');
      var searchLoading = form.find("#searchLoading");
      if(term != "") {
        
        if( e.keyCode != 17 && e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40){
      		var search_string = 'sku:'+term+'*&q=body:'+term+'*&q=title:'+term+'*';
      		var srch_url = '/search?type=product&qs='+term+'&q='+search_string;
      		var searchURL = decodeURIComponent(srch_url);
      		jQuery(".hidden_query").val(search_string);
      
      
            if (term.length >= 1) {
              jQuery(this).attr('data-old-term', term);
              if (currentAjaxRequest != null) currentAjaxRequest.abort();
              resultdiv.show();
              searchLoading.css('display','block');
              currentAjaxRequest = jQuery.getJSON(searchURL + '&view=json', function(data) {


                resultsList.empty();
                if(data.results_count == 0) {
                  searchLoading.css('display','none');
                   resultsList.html('<li><span class="title">No Results Found.</span></li>');
                   resultdiv.show();
                   resultsList.show();
                } else {
                  searchLoading.css('display','none');
                  jQuery.each(data.results, function(index, item) {

                    var link = jQuery('<a href="'+item.url+'" target="_blank"></a>');
                    link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                    link.append('<span class="title">' + item.title + '</span>');
                    link.wrap('<li></li>');
                    resultsList.append(link.parent());
                  });
                  if(data.results_count > 10) {
                      resultsList.append('<li class="view-btn"><a href="' + searchURL + '" class="btn text-center">See all results (' + data.results_count + ')</a></li>');

                  }
                   resultsList.show();
                }        
              });
            } 
            else{
              resultsList.empty();
              resultsList.show();
              resultdiv.show();
            }
      	}
        
      } else {
        
          resultsList.empty();
          resultdiv.hide();
          return false;
      }
    });
  });
  
};

// End

// Shop By Brand List
poshecommerce.brandList = function(){
  jQuery( ".vendor-letter" ).click(function() {
     var latter = jQuery(this).text();
     if(latter == "All"){
       jQuery("ul.vendorListDisplay li.openList").css("display","block");
       jQuery("ul.vendorListDisplay span.openList").css("display","block");
     }
     else{       
     	jQuery("ul.vendorListDisplay li.openList").css("display","none");
        jQuery("ul.vendorListDisplay span.openList").css("display","none");
     	jQuery("ul.vendorListDisplay li."+latter).css("display","block");
       jQuery("ul.vendorListDisplay span."+latter).css("display","block");
     }
   });
};


// End Shop By Brand List


poshecommerce.settingMenu = function(){
  // Setting Menu
  jQuery(".setting-toggle").click(function(e) {
    jQuery(".settinglinks").slideToggle();
    e.preventDefault();
  });
  // End Setting Menu
  
  // Topbar-Menu
  jQuery('.topmenu-toggle').on("click",function(e){
		if (jQuery(window).width() < 998 ) {
			jQuery('.top-link').slideToggle();
		}
	jQuery('.top-link').toggleClass('toggled-on');
    e.preventDefault();
  });
		
  // Resize Function
  jQuery(window).on("load resize",function(e){
	if (jQuery(window).width() > 998	  ) {
		jQuery(".top-link").show();
	}
	else {
		jQuery(".top-link").hide();
	}
  });	
}

poshecommerce.HoverMenu = function(){
  jQuery('.parent.mega-menu').hover(function(){
    jQuery(this).addClass('hoverMenu');
    }, function(){
    jQuery(this).removeClass('hoverMenu');
  });
  jQuery('.parent.megamenu').hover(function(){
    jQuery(this).addClass('hoverMenu');
    }, function(){
    jQuery(this).removeClass('hoverMenu');
  });
   jQuery('.parent.dropdown').hover(function(){
    jQuery(this).addClass('hoverMenu');
    }, function(){
    jQuery(this).removeClass('hoverMenu');
  });
}

// Quick Orders

poshecommerce.quickOrders = function(){
  if(!jQuery("#orderformpage").length){   
    return ;
  }
  var coll_handle = jQuery("#choose_coll option:selected").val();
  var pg_no = 1;
  var ajax_url = '/collections/'+coll_handle+'?page='+pg_no+'&view=get-orderitems';
  function print_html(response)
  {
   
    	if(/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
    		var input_type = 'number';  
   		} else {                       
    		var input_type = 'text';
        }
    
   	    //If there are no items in collection then hide multiaddtocart bttn
        if(response.total_items==0) {
          jQuery(".multiaddtocart").css("display","none");
          jQuery("table#order_items").hide();
          jQuery("#order_noresult").show();
        } else {
          jQuery("table#order_items").show();
          jQuery("#order_noresult").hide();
          jQuery(".multiaddtocart").css("display","block");
        }
        
        if(response.total_pages > 1 && response.total_items > 10) {
        jQuery(".orderitems_paging").html('<button class="prev_paging" type="button" title="Previous">&lt;&lt;</button><span class="current_page" data-currpage="'+response.current_page+'">'+response.current_page+'</span><button title="Next" class="next_paging" type="button">&gt;&gt;</button>');
        
        if(response.current_page > 1) {
          jQuery(".prev_paging").prop("disabled", false);
        } else {
          jQuery(".prev_paging").prop("disabled", true);
        }
        
        if(response.current_page != response.total_pages) {
          jQuery(".next_paging").prop("disabled", false);
        } else {
          jQuery(".next_paging").prop("disabled", true);
        }
        
        } else {
        jQuery(".orderitems_paging").empty();
        }
        
        jQuery('#item_results').empty();
        jQuery('.discription_div').empty();
    	
        jQuery.each(response.order_items,function(index,item) {
           
          	var row = jQuery('<tr class="multicart" id="prditem-'+item.prd_id+'">');
            row.append(jQuery('<td>').html('<p><a href="javascript:void(0)" class="var_title_'+item.prd_first_variant_id+'">'+item.prd_title+'</a>&nbsp;&nbsp;<button type="button" class="descBtn" title="" data-productid="'+item.prd_id+'"><i class="fa fa-angle-right" aria-hidden="true"></i> <span class="tooltip">Description</span> </span></button></p>'));
 			row.append(jQuery('<td>').html('<img src="'+item.prd_img+'" height="150px" width="150px" alt="'+item.prd_title+'">')); 
          
          	if(Currency.format == "money_format") {
            var itemPrice = Shopify.formatMoney(Currency.convert(item.prd_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format);
            } else {
            var itemPrice = Shopify.formatMoney(Currency.convert(item.prd_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format)+" "+Currency.currentCurrency;
            }
          
          	row.append(jQuery('<td>').html('<p><span class="money">'+itemPrice+'</span></p>')); 
          	
          	/* Brand / SKU */
           	var item_brand = "Brand: "+item.prd_brand;
            
            if(item.prd_sku != "") {
            var item_sku = "Product SKU: "+item.prd_sku;
            } else {
            var item_sku = item.prd_sku;
            }
          
          	row.append(jQuery('<td>').html('<p>'+item_brand+'</p><p>'+item_sku+'</p>')); 
	
           if(item.prd_soldout == "yes") {
             
            row.append(jQuery('<td>').html('')); 
           	row.append(jQuery('<td>').html('<span class="label soldout">Sold Out</span>'));
            jQuery('#item_results').append(row);  
            
             
           } else {
             
             if(item.prd_variants.length > 1) {
               
                row.append(jQuery('<td>').html(""));
               	row.append(jQuery('<td>').html('<input data-variantproid="variantof-'+item.prd_id+'" type="button" value="Show Options" name="selectVariant" class="showhidevariant" style="cursor:pointer;"/>'));
               	jQuery('#item_results').append(row);  
               
                var dynamic_columns = "";
               
                if(item.option1 != "") {
                  dynamic_columns = "<th>"+item.option1+"</th>";
                }
               
               	if(item.option2 != "") {
                  dynamic_columns+= "<th>"+item.option2+"</th>";
                }
               
                if(item.option3 != "") {
                  dynamic_columns+= "<th>"+item.option3+"</th>";
                }
               
               	var variant_row = jQuery('<tr style="display:none;" class="multicart variantof-'+item.prd_id+'">');
  				variant_row.append(jQuery('<td colspan="6" class="show-product">').html('<table class="prd_variants_'+item.prd_id+'"><thead><tr class="var_header">'+dynamic_columns+'<th>Product Image</th><th>Price</th><th>Brand/SKU</th><th>Quantity</th><th></th></tr></thead><tbody>'));
                variant_row.append(jQuery('</td>').html('</tbody></table>'));
               	jQuery('#item_results').append(variant_row); 
              
            	jQuery.each(item.prd_variants,function(vrnt_index,vrnt_item) {
               	
                	var multtbl = jQuery('#item_results .prd_variants_'+item.prd_id+' tbody');
               
                 	multtbl.append(jQuery('<tr class=varitem_'+vrnt_item.vrnt_id+'>')); 
                  
                  	var var_row = jQuery('#item_results .prd_variants_'+item.prd_id+' tbody').find('tr.varitem_'+vrnt_item.vrnt_id);
                    if(vrnt_item.vrnt_option1 != "") {
                    var_row.append(jQuery('<td>').html('<p>'+vrnt_item.vrnt_option1+'</p>'));
                    }
                  
                   	if(vrnt_item.vrnt_option2 != "") {
                    var_row.append(jQuery('<td>').html('<p>'+vrnt_item.vrnt_option2+'</p>'));
                    }
                  
                    if(vrnt_item.vrnt_option3 != "") {
                    var_row.append(jQuery('<td>').html('<p>'+vrnt_item.vrnt_option3+'</p>'));
                    }
                  
                  	var_row.append(jQuery('<td>').html('<p><span class="var_title_'+vrnt_item.vrnt_id+'" style="display:none;">'+vrnt_item.vrnt_title+'</span><img src="'+vrnt_item.vrnt_img+'" height="150px" width="150px" style="max-width:150px;max-height:150px;"></p>'));
                	
                  	if(Currency.format == "money_format") {
                 	var varPrice = Shopify.formatMoney(Currency.convert(vrnt_item.vrnt_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format);
               		} else {
                 	var varPrice = Shopify.formatMoney(Currency.convert(vrnt_item.vrnt_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format)+" "+Currency.currentCurrency;
               		}
                  
                  	var_row.append(jQuery('<td>').html('<p><span class="money"><b>'+varPrice+'</b></span></p>'));
                    
                  	/* Brand / SKU */
                    var brand_html = "Brand: "+item.prd_brand;
                   
                  	if(vrnt_item.vrnt_sku != "") {
                       var sku_html = "Product SKU: "+vrnt_item.vrnt_sku;
                    } else {
                      var sku_html = vrnt_item.vrnt_sku;
                    }
                  
                  	var_row.append(jQuery('<td>').html('<p>'+brand_html+'</p><p>'+sku_html+'</p>'));
                    
                  	if(vrnt_item.vrnts_sold_out == "yes") {
                        var_row.append(jQuery('<td>').html(""));
                    	var_row.append(jQuery('<td>').html('<span class="label soldout">Sold Out</span>'));
                      
                    } else {
                      
                      	if(vrnt_item.variant_max != "") {
                      	 var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+vrnt_item.vrnt_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+vrnt_item.vrnt_id+'" class="list-product-qty currqty_'+vrnt_item.vrnt_id+'" type="'+input_type+'" value="0" name="updates[]" size="4" min="0" max="'+vrnt_item.variant_max+'"><input style="cursor:pointer;" id="qtyplus-'+vrnt_item.vrnt_id+'" class="qtyplus" type="button" value="+"><p>In Stock: '+vrnt_item.variant_max+'</p></div>';
                      	}else {
                      	 var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+vrnt_item.vrnt_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+vrnt_item.vrnt_id+'" class="list-product-qty currqty_'+vrnt_item.vrnt_id+'" type="'+input_type+'" value="0" name="updates[]" size="4" min="0" max="'+vrnt_item.variant_max+'"><input style="cursor:pointer;" id="qtyplus-'+vrnt_item.vrnt_id+'" class="qtyplus" type="button" value="+"></div>';
                        }	
                      
                      	var_row.append(jQuery('<td>').html(qty_html));
                      
                  		var addtocart_html = '<div class="qty-form"><form method="post" action="/cart/add" class="AddToCart"><input type="hidden" name="id" value="'+vrnt_item.vrnt_id+'" /><input type="button" value="Add to Cart" id="'+vrnt_item.vrnt_id+'" class="btn btnCart" /></form></div>';
						var_row.append(jQuery('<td>').html(addtocart_html));
                    } 
                });
               
             } else {
               
               if(item.prd_max != "") {  
                 var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+item.prd_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+item.prd_first_variant_id+'" class="list-product-qty currqty_'+item.prd_first_variant_id+'" type="'+input_type+'" value="0" name="updates[]" size="4" min="0" max="'+item.prd_max+'"><input style="cursor:pointer;" id="qtyplus-'+item.prd_id+'" class="qtyplus" type="button" value="+"><p>In Stock: '+item.prd_max+'</p></div>';
               } else {
                 var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+item.prd_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+item.prd_first_variant_id+'" class="list-product-qty currqty_'+item.prd_first_variant_id+'" type="'+input_type+'" value="0" name="updates[]" size="4" min="0" max="'+item.prd_max+'"><input style="cursor:pointer;" id="qtyplus-'+item.prd_id+'" class="qtyplus" type="button" value="+"></div>';
               }
               
                row.append(jQuery('<td>').html(qty_html));
                  
               var addtocart_html = '<div class="qty-form"><form method="post" action="/cart/add" class="AddToCart"><input type="hidden" name="id" value="'+item.prd_first_variant_id+'"><input type="button" value="Add to Cart" id="'+item.prd_first_variant_id+'" class="btn btnCart" /></form></div>';
			   row.append(jQuery('<td>').html(addtocart_html));
               
               jQuery('#item_results').append(row);  
             }
           }
          
           /* Append Product Description in a Modal */
           var desc_content = jQuery.parseJSON(item.prd_desc); 
           jQuery('#orderformpage .discription_div').append('<div id="descModal-'+item.prd_id+'" class="desc_modal" data-productid="'+item.prd_id+'"><div class="desc-modal-content"><div class="quickmodal-header"><button type="button" class="desc-close" data-productid="'+item.prd_id+'" title="Close">&times;</button><h2>'+item.prd_title+'</h2></div><div class="quickmodal-body"><div class="order-desc"><span class="prd-image"><img src="'+item.prd_img+'" alt="'+item.prd_title+'"></span> '+desc_content+'</div></div></div></div>');
        });
  }
  
  //Send AJAX Request
  function get_orderitems(ajax_url,pg_no) 
  { 
    
    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function() {
    if(httpRequest.readyState === XMLHttpRequest.DONE) {
      if(httpRequest.status === 200) {
        //jQuery(".orderform-loader").css("display","none");
        jQuery("body").removeClass("loading");
        var response = jQuery.parseJSON(httpRequest.responseText);
       
        print_html(response);
        
      }
    }
   };
    
   //jQuery(".orderform-loader").css("display","inline");
     jQuery("body").addClass("loading");
   httpRequest.open('GET',ajax_url, true);
   httpRequest.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
   httpRequest.send();
 }
  
 //Onpageload - Get all products
 get_orderitems(ajax_url,pg_no);
  
  
 //Get Next page items on paging link clicked
 jQuery(document).on("click",".orderitems_paging button.next_paging", function() {
   var curr_pageno = jQuery(".orderitems_paging .current_page").data("currpage");
   var next_pageno = parseInt(curr_pageno)+1;
   var chosen_coll = jQuery("#choose_coll option:selected").val();
   var order_srch_term = jQuery.trim(jQuery("input#search_ord_item_term").val());
   var sort_by = jQuery("#sort_by option:selected").val();
   
   if(order_srch_term != "") {
      jQuery('#sort_by_container').hide();
      var ajax_url = '/search?q='+order_srch_term+'*&type=product&view=get-orderitems&page='+next_pageno;
      ajax_url = decodeURIComponent(ajax_url);
   
   } else {
      jQuery('#sort_by_container').show();
      var ajax_url = '/collections/'+chosen_coll+'?page='+next_pageno+'&view=get-orderitems&sort_by='+sort_by;
   }
   
   get_orderitems(ajax_url,next_pageno); 
 });
  
  
 //Get Previous page items on paging link clicked
 jQuery(document).on("click",".orderitems_paging button.prev_paging", function() {
   var curr_pageno = jQuery(".orderitems_paging .current_page").data("currpage");
   var prev_pageno = parseInt(curr_pageno)-1;
   var chosen_coll = jQuery("#choose_coll option:selected").val();
   var ajax_url = '/collections/'+chosen_coll+'?page='+prev_pageno+'&view=get-orderitems';
   var order_srch_term = jQuery.trim(jQuery("input#search_ord_item_term").val());
   var sort_by = jQuery("#sort_by option:selected").val();
   
   if(order_srch_term != "") {
   jQuery('#sort_by_container').hide();
   var ajax_url = '/search?q='+order_srch_term+'*&type=product&view=get-orderitems&page='+prev_pageno;
   ajax_url = decodeURIComponent(ajax_url);
   } else {
   jQuery('#sort_by_container').show();
   var ajax_url = '/collections/'+chosen_coll+'?page='+prev_pageno+'&view=get-orderitems&sort_by='+sort_by;
   }
 
    get_orderitems(ajax_url,prev_pageno); 
 });
  
  
 //Onchange collection dropdown - Get Produts of that collection
 jQuery("#choose_coll").on("change",function() {
   	var chosen_coll = jQuery("#choose_coll option:selected").val();
    var sort_by = jQuery("#sort_by option:selected").val();
    var ajax_url = '/collections/'+chosen_coll+'?page='+pg_no+'&view=get-orderitems&sort_by='+sort_by;
   	
    jQuery("#search_ord_item_term").val("");  //Reset Search Term
    jQuery('#sort_by_container').show();
   
    get_orderitems(ajax_url,pg_no);
 });
 
  
 //Onkeyup Search
 jQuery("input#search_ord_item_term").keyup(function(event) {
   	var order_srch_term = jQuery.trim(jQuery(this).val());
   	var ajax_url = '/search?q='+order_srch_term+'*&type=product&view=get-orderitems&page=1';
    ajax_url = decodeURIComponent(ajax_url);
   
    jQuery('#choose_coll').val("all"); //Reset coll dropdown to all categories
    
   	if(order_srch_term != "") {
      jQuery('#sort_by_container').hide();
    } else {
      jQuery('#sort_by_container').show();
    }
    get_orderitems(ajax_url,pg_no);
  });
  
  //Prevent Form submission on Enter key press
  jQuery("input#search_ord_item_term").keypress(function(event) {
     if(event.keyCode == 13) {
      	event.preventDefault();
      	return !1;
     }
  });
  
  //Sorting Collection Products by sort order
  jQuery("#sort_by").on("change",function() {
   	var sort_by = jQuery("#sort_by option:selected").val();
    var chosen_coll = jQuery("#choose_coll option:selected").val();
    var pg_no = jQuery('.orderitems_paging .current_page').data("currpage"); 
    var ajax_url = '/collections/'+chosen_coll+'?page='+pg_no+'&view=get-orderitems&sort_by='+sort_by;
    get_orderitems(ajax_url,pg_no);
 });
  
  //When the user clicks the button, open the modal 
  jQuery(document).on("click",'.descBtn',function() {
    var desc_pr_id = jQuery(this).data("productid");
    var modal_id = "descModal-"+desc_pr_id;
  
  	jQuery('#'+modal_id).css('display','block');
  });
  
  //When the user clicks on x,close the modal
  jQuery(document).on("click",'.desc-close',function() {
    var desc_pr_id = jQuery(this).data("productid");
    var modal_id = "descModal-"+desc_pr_id;
    
  	jQuery('#'+modal_id).css('display','none');
  });
  
  //When the user clicks anywhere outside of the modal , close it
  jQuery(document).bind("click touchend",function(e) {
  	var $Modal = jQuery('.desc_modal');
	var $target = e.target; 

   	if(($Modal).is($target)) {    
     jQuery('.desc_modal').css('display','none');
	}
  });
  
};

// End Quick Orders

// Cart Modal Module
poshecommerce.cartModal = function(){
  poshecommerce.cartElement = {
	    $html                    : jQuery('html'),
	    $body                    : jQuery('body'),
	    $cartModal     		     : jQuery('#list-modal-view'),
    	$searchInput 			 : jQuery('#qs'),
	    $cartButton     		 : jQuery('#list-modal-btn'),
        $modalClose              : jQuery('#modalClose')
  };
  
  poshecommerce.cartElement.$cartButton.bind("click", function(e) {
        if(jQuery('#list-modal-view .modalError').length){
          jQuery('.modalError').remove();
        }
    	poshecommerce.cartElement.$cartModal.show();
    	
        e.preventDefault();
  });
  poshecommerce.cartElement.$modalClose.bind("click touchend", function(e) {
    	poshecommerce.cartElement.$cartModal.hide();
        e.preventDefault();
  });
  jQuery(document).bind("click touchend", function(e) {
    	$Modal = poshecommerce.cartElement.$cartModal;
		$target = e.target; 
        if(($Modal).is($target)) {
            poshecommerce.cartElement.$cartModal.hide();
		}
  });
  
};
// End Cart Modal

poshecommerce.cartFly = (function(jQuery){
 
 function flyToElement(flyer, flyingTo, from ,callBack) {
				var $func = jQuery(this);
				var divider = 3;
 				var flyerClone = jQuery(flyer).clone();
   				var top = '';
   				var left = '';
   				var right = '';
   				var width = '';
   				var height = '';
   				var animateW = '';
   				var animateH = '';
   				if(from == "cart"){
                  if(jQuery("#wishlist-products").length){
                     top    = '157px';
                     left   = '218px';
                     right  = '50px';
                     animateW = jQuery(flyer).width()/divider ;
                     animateH = jQuery(flyer).height()/divider;
                  }
                  else{
                     
                     top 	= jQuery(flyer).offset().top + "px";
                     left 	=  jQuery(flyer).offset().left + "px";
                     width 	= 200;
                     height = 250;
                     animateW = jQuery(flyer).width()/divider ;
                     animateH = jQuery(flyer).height()/divider;
                  }
                }
   				else{
                  	top = jQuery(flyer).offset().top + "px";
                    left 	=  jQuery(flyer).offset().left + "px";
                    width = 200;
					height = 250;
                    animateW = jQuery(flyer).width()/divider ;
                    animateH = jQuery(flyer).height()/divider;
   				}   
     
    			jQuery(flyerClone).css({
                      'position': 'absolute',
                      'top': top,
                      'left': left,
                      'right':right,
                  	  'width': width,
					  'height': height,
                      'opacity':'1',
                      'z-index': '1000'
                });
    
				jQuery('body').append(jQuery(flyerClone));
                
 				var gotoX = jQuery(flyingTo).offset().left + (jQuery(flyingTo).width() / 2) - (jQuery(flyer).width()/divider)/2;
				var gotoY = jQuery(flyingTo).offset().top + (jQuery(flyingTo).height() / 2) - (jQuery(flyer).height()/divider)/2;
   				jQuery(flyerClone).animate({
                       'opacity':'1',
                       'left': gotoX,
                       'top': gotoY,
                	   'width': animateW,
                       'height': animateH
                    }, 700,
                      function () {                  
                         jQuery(flyingTo).fadeOut('fast', function () {
                            jQuery(flyingTo).fadeIn('fast', function () {
                                jQuery(flyerClone).fadeOut('fast', function () {
                                    jQuery(flyerClone).remove();
                                      if( callBack != null ) {
                                                callBack.apply($func);
                                      }
                                });
                             });
                          });
                 });
			} 
  return {
    flyToElement: flyToElement,
  }
}(jQuery));



// Multiple Add To Cart

poshecommerce.multiAddToCart = (function(jQuery){
  poshecommerce.multiAddToCartEle = {
    $listProductQty     : '.list-product-qty',
    $qtyplus            : '.qtyplus',
    $qtyminus           : '.qtyminus',
    $showhidevariant    : '.showhidevariant',
    $error: 0,
  };
  
  function init(){
    multiCartClick(),listQty(),incDecQty(),showHideOption(),current_item_list;
  }
  
  function pushitems(el,product_id) 
  {
      var currentQty = parseInt(jQuery(el).val()) || 0;
      current_item_list.items = jQuery.grep(current_item_list.items, function(e){ 
    	if(e.product_id == product_id) {
       		return false;
     	} else {
       		return true;
        }
      });      	
      current_item_list.items.push({'product_id': product_id,'qty': currentQty});
  }
  function multiCartClick(){
    jQuery(document).on('click','.current_list-add-to-cart',function(){
      	current_item_list.addItems();
    });
  }
  var current_item_list = {
    items: [],
    errors:[],
    addItems: function() {
      
      if(this.items.length) {
        
        
        jQuery.each(this.items, function(k,arr){
          
         // CartJS.addItem(arr['product_id'],arr['qty']);
          var success = 0;
          var error = 0;
          // Test
          
          
          CartJS.addItem(arr['product_id'], arr['qty'], {     
          }, {
              "success": function(data, textStatus, jqXHR){
               // success = parseInt(success) + 1 ;
                
               // current_item_list.errors.push({'success':success});
              },
              "error": function(jqXHR, textStatus, errorThrown){
                
                error = parseInt(error) + 1 ;
                var response = eval('(' + jqXHR.responseText + ')');
                response = response.description;
                current_item_list.errors.push({'error':response});
            		//	response = response.description;
                 // 		current_item_list.errors.push({'err_res':response});
                   
               //current_item_list.errors.push({'error':error});

              }
          });
        });
        
        reset_current_list();
       
         
      }
    },
  }
  function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  function listQty(){
    jQuery(document).on('keyup','.list-product-qty',function() {
         	var ele_id = jQuery(this).attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var $qtyInput = jQuery("#"+ele_id);
            var currentVal = parseInt($qtyInput.val()) || 0;
  		    var qtyMax = parseInt($qtyInput.attr('max'));
            var title = jQuery(".var_title_"+product_id).text();
         
  			if(currentVal > qtyMax) {
          		alert("We have max "+qtyMax+" items in stock ");
   		 		$qtyInput.val(qtyMax);	
  			} 
         
         	if(currentVal >= 1) {
  				pushitems($qtyInput,product_id);
            } else {
            	current_list_remove(product_id);
         	}
	 });
     jQuery(document).on('keypress','.list-product-qty',function(evt) {
       var isno = isNumber(evt);
       if(!isno) {
         return false;
       }
     });
  
  }
  function incDecQty(){
    	/* Increment qty function */
       jQuery(document).on('click','.qtyplus',function() {     
          
          	var ele_id = jQuery(this).siblings(".list-product-qty").attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var $qtyInput = jQuery("#"+ele_id);
  			var currentVal = parseInt($qtyInput.val());
  			var qtyMax = parseInt($qtyInput.attr('max'));
          	var title = jQuery(".var_title_"+product_id).text();
         
          	if(currentVal >= qtyMax) {
              	alert("We have max "+qtyMax+" items in stock ");
   		 		$qtyInput.val(qtyMax);
              
  			} else {
  				$qtyInput.val(currentVal+1);	
          	}
          
          	pushitems($qtyInput,product_id);
		});
  
  
  		/* Decrement qty function */
		jQuery(document).on('click','.qtyminus',function() {    
          
          	var ele_id = jQuery(this).siblings(".list-product-qty").attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var $qtyInput = jQuery("#"+ele_id);
  			var currentVal = parseInt($qtyInput.val());
          
    		if(currentVal >= 1) {
      			$qtyInput.val(currentVal - 1);
           		pushitems($qtyInput,product_id);
   		 	} else {
              	current_list_remove(product_id);
            }
	    });
   }
  function showHideOption(){
     	/* Show / hide variant options */
  		jQuery(document).on('click','.showhidevariant',function() { 
          
           	var varintof_productid = jQuery(this).data("variantproid");
           	jQuery("."+varintof_productid).toggle();
           		jQuery(this).val(function(i,val){
            	return val === "Show Options" ? "Hide Options" : "Show Options";
      		});
        });
  }
  function current_list_remove(remove_prdid)
   {
     
    	current_item_list.items = jQuery.grep(current_item_list.items, function(e){ 
  
    		if(e.product_id == remove_prdid) {
       			return false;
     		} else {
       			return true;
    		}
   		});   
     	
     	return true;
   }
   function reset_current_list() 
   {
     
     	jQuery('.list-product-qty').val(0).trigger("change");
     	jQuery(".qty-form .btnCart").val("Add to Cart");
     	
        setTimeout(function(){  
          var errorTotal = '';
          jQuery.each(current_item_list.errors, function(k,arr){
           
            if(arr['error']){
            	errorTotal = errorTotal + arr['error'] + '<br>';
             
            }
          }); 
       
          current_item_list.errors = [];
       	  current_item_list.items = [];
          
         // if(successTotal != 0){
            if(jQuery("#list-modal-view").length ){
                jQuery("#quick-view-product").hide();
                jQuery('.modalError').remove();              
                jQuery( "<div class='modalError'><p style='color: red;'>"+errorTotal+"</p></div>" ).insertAfter( ".modal-content .modal-header" );
                jQuery("#list-modal-view").css("display","block");
                errorTotal = '';
            }
            if (jQuery('#drawer-menu01').length) {
                jQuery('.drawerError').remove(); 
                jQuery( "<div class='drawerError'><p style='color: red;'>"+errorTotal+"</p></div>" ).insertAfter('#drawer-menu01 #cart-title');
                jQuery("#quick-view-product").hide();              
                poshecommerce.cartDrawer.showCartDrawer();
                errorTotal = '';
            }
            if(jQuery("#pageLoad").length ){
                     window.location = "/cart";
            }
         // }
       }, 3000);
		
    	
   }
  return {
    		init: init,
    		reset_current_list:reset_current_list,
    		current_item_list:current_item_list,
  }
}(jQuery));

//End

// Cart Drawer Module
poshecommerce.cartDrawer = (function(jQuery) {
  		poshecommerce.cartDrawerElement = {
	    	$html                    : 'html',
	    	$body                    : 'body',
	    	$cartDrawerClick     	 : '#drawer-click',
    		$cartDrawer 			 : '#drawer-menu01',
            $drawerMenuBody          : 'drawer-menu-body',
          	$drawerMenuPage			 : 'drawer-menu-page',
            $overlay                 : '#overlay',
            $header                  : 'div#shopify-section-header',
            $quickView               : 'div#quick-view-product',
            $PageContainer           : '#PageContainer',
            $successDrawer           : '#successDrawer',
            $modalOverly             : '.modalOverly',
            $loadingBox              : 'div.loadingBox'
    	
  		};
  	    function init() {
          
        	if(jQuery(poshecommerce.cartDrawerElement.$cartDrawer).length){
      			initCartDrawer(),CartDrawerClick(),closeCartDrawer();
          	}       
     	}
  		function CartDrawerClick(){
          jQuery(poshecommerce.cartDrawerElement.$cartDrawerClick).bind("click", function(e) {
            if(jQuery('#drawer-menu01 .drawerError').length){
              jQuery('.drawerError').remove();
            }
            jQuery.drawer_menu.toggle(poshecommerce.cartDrawerElement.$cartDrawer);
            jQuery('#overlay').css('display','block');
           
          });
  		}
  		function closeCartDrawer(){
          jQuery(document).bind("click", function(e) {
              var target = e.target; 
                if(!jQuery(e.target).closest(poshecommerce.cartDrawerElement.$cartDrawer).length && !jQuery(e.target).closest("#shopify-section-header").length && !jQuery(e.target).closest(poshecommerce.mobileSideNavDrawerElement.$menuDrawer).length) {
                  
                  jQuery(poshecommerce.cartDrawerElement.$overlay).css('display','none');
                  jQuery(poshecommerce.cartDrawerElement.$cartDrawer).drawer_menu("close");
                  //setTimeout(function() { 
                          jQuery(poshecommerce.cartDrawerElement.$header).removeAttr('style');    
                          jQuery(poshecommerce.cartDrawerElement.$quickView).css({'left':'','transform':''}); 
                  		  jQuery("#SearchDrawer").removeAttr('style');  
                          jQuery(poshecommerce.cartDrawerElement.$PageContainer).css({'left':'','transform':''});
                          jQuery(poshecommerce.cartDrawerElement.$successDrawer).css({'left':'','transform':''});
                          jQuery(poshecommerce.cartDrawerElement.$modalOverly).css({'left':'','transform':''});
                          jQuery(poshecommerce.cartDrawerElement.$loadingBox).css({'left':'','transform':''});
                  //}, 500);
              }
			});
  		}
     	function initCartDrawer(){
         
          if(jQuery(poshecommerce.cartDrawerElement.$cartDrawer).length){
          jQuery(poshecommerce.cartDrawerElement.$body).addClass(poshecommerce.cartDrawerElement.$drawerMenuBody);
          jQuery(poshecommerce.cartDrawerElement.$body).addClass(poshecommerce.cartDrawerElement.$drawerMenuPage);
          
          //setTimeout(function(){ 
            
            jQuery(poshecommerce.cartDrawerElement.$cartDrawer).drawer_menu({
            	speed : 200,
            	child_speed : 200,
            	cssAnimation : true,
            	resizePer : true,
            	beforeOpen : function(){

               		jQuery(document).scrollTop(0);
               		jQuery(poshecommerce.cartDrawerElement.$overlay).css('display','block');
            	},
            });
          
         // }, 1000);
          
      	}
        }
        function showCartDrawer(){
         		jQuery.drawer_menu.toggle(poshecommerce.cartDrawerElement.$cartDrawer);
    			jQuery('#overlay').css('display','block');
        }
        return {
    		init: init,
            showCartDrawer: showCartDrawer,
   
  		}
}(jQuery));

// End Cart Drawer

/*********************Add view to collection*****************/
poshecommerce.changeView = (function(jQuery) {
  poshecommerce.viewElement = {
    $changeView : jQuery('.change-view')
  };
  function init() {
    changeViewClick();
  }
  function changeViewClick(){
    poshecommerce.viewElement.$changeView.bind("click touchend", function(event) {
       event.preventDefault();
       if(jQuery(this).hasClass('change-view--active')) return false;
       jQuery(".change-view").removeClass('active');
       jQuery(this).addClass('active');
       var url      = window.location.href;  
       var urlParams = new URLSearchParams(window.location.search);
       if(urlParams.get('view') != jQuery(this).data('view')){
       		url = replaceUrlParam(url, 'view', jQuery(this).data('view'));
       }
       jQuery('.product_list').removeClass('list').removeClass('grid').addClass(jQuery(this).data('view'));
       
       processCollectionAjax(url);
       
       return false;
    });
  }
  function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
        newUrl = url.replace(pattern,'$1' + paramValue + '$2');
    if ( newUrl == url ) {
        newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
  }
     
  function processCollectionAjax(url){
  jQuery("body").addClass("loading");
      jQuery.ajax({
          type: 'GET',
          url: url,
          data: {},
          beforeSend:function(){
              jQuery('.product_list').addClass('loading');
          },
          complete: function (data) {
            jQuery("body").removeClass("loading");
            jQuery('.product_list').html(jQuery(".product_list", data.responseText).html());


             /*** Added to solve problem due to limit of grid when there is no load more bttn set then it will not set
            buttn on list view also- Darakhsa ***/
           if(jQuery('#product-list-foot').length==0)
           {
             if(jQuery("#product-list-foot", data.responseText).html() != undefined)
             {
               
               var moreHTML = "<div id='product-list-foot'>"+jQuery("#product-list-foot", data.responseText).html()+"</div>";
               jQuery( moreHTML ).insertAfter( jQuery( ".product_list" ) );
               
             }
           } else{
             jQuery('#product-list-foot').html(jQuery("#product-list-foot", data.responseText).html());
             poshecommerce.collectionSwatches.init();
             poshecommerce.productGridCounter.init();
             
           }
          /*** Ended here - Darakhsa ***/  
              jQuery('.product_list').removeClass('loading').removeClass('grid');
              ShowMoreEvent()
              wishlist_product_handle();
              if(jQuery(".spr-badge").length > 0) {
                //this line is added to fix big review star problem in IE11
                jQuery('link[rel=stylesheet][href*="spr"]').remove();
                //ended here
                jQuery.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
              }
              Currency.convertAll(Currency.default_curr, Currency.currentCurrency, 'span.money', Currency.format);
              history.pushState({
                  page: url
              }, url, url);
             // pagingCollection();
          }
      });
  }
  function pagingCollection(){
      activeNumber = parseInt(jQuery('.pagination li.active span').html());
      jQuery('#pagination .pagination a').click(function(){
          var pageNumber = 0;
          //previous

          if(jQuery(this).parent().hasClass('pagination_previous')){
              pageNumber = activeNumber-1;
          }
          //next
          else if(jQuery(this).parent().hasClass('pagination_next')){
              pageNumber = activeNumber+1;
          }
          //normal paging
          else{
              pageNumber = parseInt(jQuery(this).html());
          }
          if(pageNumber >0){
              var url      = window.location.href;
              url = replaceUrlParam(url, 'page', pageNumber);
              processCollectionAjax(url);
          }
          return false;
      });
  }
  return {
    init: init,
  }
  
})(jQuery);
/********************* End Add view to collection*****************/

/*================ Sidebar Dropdown ==============*/

poshecommerce.sidebarDropdown = function(){
  poshecommerce.sideElement = {
    $blockTitle 	: jQuery('.block .block-title'),
    $blockShopBlock : jQuery('.block .Shopblock-title')
  };
  poshecommerce.sideElement.$blockTitle.bind("click", function(e) {
    if (jQuery(window).width() < 999 ) {
     	jQuery(this).next().slideToggle();
     	jQuery(this).toggleClass("active");
        e.preventDefault();
    }
  });

  jQuery(document).on("click",".block .Shopblock-title",function(e) {
  //poshecommerce.sideElement.$blockShopBlock.bind("click", function(e) {
     if (jQuery(window).width() < 999 ) {
       
     	jQuery(this).next().slideToggle();
       	if(jQuery(this).hasClass("active")){
          jQuery(this).removeClass("active");
       	}
        else{
          jQuery(this).addClass("active");
        }
     	//jQuery(this).toggleClass("active");
        e.preventDefault();
     }
  });
}

/*================ End Sidebar Dropdown ==============*/

/*================  Footer Dropdown ==============*/

poshecommerce.footerDropdown = function(){
  poshecommerce.footerElement  = {
    $ftrLinks : jQuery('.ftrLinks h4')
  };
  poshecommerce.footerElement.$ftrLinks.bind("click touchend", function(e) {
     if (jQuery(window).width() < 768 ) {
       jQuery(this).next().slideToggle();
       if(jQuery(this).hasClass("active")){
         jQuery(this).removeClass("active");
       }
       else{
         jQuery(this).addClass("active");
       }
     	//jQuery(this).toggleClass("active");
         e.preventDefault();
     }
  });
  jQuery(window).on("load resize",function(e){
	if (jQuery(window).width() > 768 ) {       
      	jQuery(".ftrLinks ul").show(); 
    }
	else{ 
      	jQuery(".ftrLinks ul").hide(); 
      	jQuery(".ftrLinks .html-text").hide(); 
    }
    if (jQuery(window).width() > 998 ) { 
      	jQuery(".block .block-content").show();
        jQuery(".block .content-mob").hide();
    }
	else{ 
      	jQuery(".block .block-content").hide();
    }
  });
  var resizeTimer;
  jQuery(window).resize(function (e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
          jQuery(window).trigger('delayed-resize', e);
      }, 250);
  });	 
}

/*================ End Footer Dropdown ==============*/

/*================ Sticky Header and Cart ===========*/

poshecommerce.scroll = (function(jQuery){
  var sticky_nav_class = "stickyNav fadeInDown";

  function init(){
    createCookie("minicart_closed","", 365);
    
    var previousScroll = 0;
    var enable_sticky_minicart = poshecommerce.enable_sticky_minicart;
    var enable_lazy_load = poshecommerce.enable_lazy_loading;
    var sticky_header_type = poshecommerce.sticky_header_type;
    //var sticky_nav_class = "stickyNav fadeInDown";
    if(enable_sticky_minicart && jQuery(".template-product").length>0) {
      stickyMiniCart();
      closeStickyMiniCart()
    }
    if(sticky_header_type=="reverse_sticky") {
      reverceStickyHeader();
    }
    else if(sticky_header_type=="sticky"){
      stickyHeader();
    }
    ShowMoreEvent();
    togglemenuheader7();
  }
  
  
 
  function togglemenuheader7(){
    if(jQuery(window).width() <= 998) { 
      jQuery("#show_hide").hide();
    }
    
     if(jQuery("#header_7").length){
       	tglflag = 0;
        jQuery("#show_hide").click(function () {
           
           jQuery(".nav-outer").slideToggle("fast");
           
           if(tglflag == 0){
           
           
           jQuery("#show_hide > .icon").removeClass("fa-bars");
           
           jQuery("#show_hide > .icon").addClass("fa-times");
           	tglflag = 1;
           }else{
             
             jQuery("#show_hide > .icon").removeClass("fa-times");
             
           	 jQuery("#show_hide > .icon").addClass("fa-bars");
             tglflag = 0 ;
           }
         // console.log("tglflag" + tglflag);
           
        });
       	flag = 0;
        jQuery(window).scroll(function(e){
    		
          	var lastScrollTop = jQuery('#shopify-section-header').height();
       		//var st = eval(document.documentElement.scrollTop + 10); // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
          	var st = document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      		//console.log("st " + st + "lastscrolltop " + lastScrollTop ); 
          	if(st > lastScrollTop && flag == 0){
          		jQuery(".nav-outer").hide();
              	jQuery("#show_hide").hide();
              	flag = 1;
            }else if(flag == 1 && st <= lastScrollTop){
               	jQuery(".nav-outer").show();
              	jQuery("#show_hide").show();

				jQuery("#show_hide > .icon").removeClass("fa-times");
                jQuery("#show_hide > .icon").addClass("fa-bars");
              	tglflag = 0;
              	flag = 0;
            }
          	
          	if(jQuery(".site-header").hasClass("stickyNav")){
              if(jQuery(window).width() <= 998) { 
                jQuery("#show_hide").hide();
              }else{
              jQuery("#show_hide").show();
              }
            }else{
              jQuery("#show_hide").hide();
            }
          
        });
       
		jQuery("#qs").on("blur",function(e) {
		   	setTimeout(function () {
              jQuery("#resultContainer").hide();
            }, 100);
        
        });
       	
       	jQuery("#qs").on("focus",function(e) {
          if(jQuery(".search-results").html().length > 0){
		   	setTimeout(function () {
              jQuery("#resultContainer").show();
            }, 100);
          }
        
        });
       	
		
       
     }
  }
  
  function closeStickyMiniCart(){
    jQuery('.miniaddtocart_close').bind('click',function(){
  		jQuery('#sticky_minicart').hide();
  		createCookie("minicart_closed","closed", 365);
	});  
  }
  function ShowMoreEvent(){
   
   if (jQuery(".more a").length > 0) {
     
     if(poshecommerce.auto_load_more)
     {
        jQuery(window).scroll(function(){
      	 	pInfScrExecute();
          
       		if(jQuery(document).height() - 800 > jQuery(document).scrollTop() + jQuery(window).height() ) {
        		 pInfScrDelay = 100;
       		}    
     	});
     }
     else
     {
       	jQuery(".more a").click(function(event) {
          
          if (!jQuery(this).hasClass("disabled")) {
            showMoreHandler()
          }
          event.preventDefault();
        })
     }
    }
  }
  function showMoreHandler() {
   var scrollURL = jQuery('.more a').last().attr("href");
    jQuery("body").addClass("loading");
      jQuery.ajax({
        type: "GET",
        url: scrollURL,
        success: function(data) {
          jQuery("body").removeClass("loading");
          if (jQuery(data).find(".more a").length > 0) {
           
            jQuery(".more").replaceWith(jQuery(data).find(".more"));
            if(jQuery(".more a").attr('href')) {
            
              ShowMoreEvent();
            }
          }
          else {
           
            if(jQuery(".more a").length > 0) {
              jQuery(".more a").remove();
            }
          }
          if (jQuery(data).find(".addmore").length > 0 || jQuery(data).find("#list-view-items").length > 0  ) {
            if (jQuery(data).find(".addmore").length > 0){
            jQuery(data).find(".addmore > div").each(function() {
              jQuery('.addmore').append(jQuery(this));
            });
            }
            if (jQuery(data).find("#list-view-items").length > 0){
              if(jQuery("#multi-addToCart").length){
                  jQuery(data).find('#multi-addToCart > tbody').each(function() {
                    jQuery('#multi-addToCart').append(jQuery(this));
                  });
              }
              else{
                 jQuery(data).find("#list-view-items > li").each(function() {
                  jQuery('#list-view-items').append(jQuery(this));
                 });
              }
          	}
            if(jQuery(".spr-badge").length > 0) {
              //this line is added to fix big review star problem in IE11
              jQuery('link[rel=stylesheet][href*="spr"]').remove();
              //ended here
              jQuery.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
			
			wishlist_product_handle();
           Currency.convertAll(Currency.default_curr, Currency.currentCurrency, 'span.money', Currency.format);
          }
          
			alignProductGridActions('.grid--view-items > .grid__item_eqh'); // product image equal height call
        },
        error: function(XMLHttpRequest, textStatus) {
          obj.hidePreloader();
          alert("error");
        },
        dataType: "html"
      });
  }
  function stickyMiniCart(){
    jQuery(window).scroll(function(e) 
 	{
        var currentScroll = jQuery(window).scrollTop();
    	var productsTabsDiv = jQuery(".productsTabs").offset().top;
  		
      	if(currentScroll>productsTabsDiv){
    		
          if(jQuery("#email-modal").is(':hidden')) {
            
             var minicart_closed = getCookie("minicart_closed");
			 
              if (minicart_closed == 'closed') {
               
   				jQuery('#sticky_minicart').hide();
                jQuery('.sticky-scroll-box').removeClass("cart_fixed");
                
			 } else { 
                 
                jQuery('.sticky-scroll-box').addClass("cart_fixed");
      			jQuery('.sticky-scroll-box').show();
			 } 
              
          }
        } else {
          
     	 	jQuery('.sticky-scroll-box').hide();
      		jQuery('.sticky-scroll-box').removeClass("cart_fixed");
  		}
    });
  }
  function reverceStickyHeader(){
	 var previousScroll = 0;
     jQuery(window).scroll(function(e) 
 	 {
       	  var currentScroll = jQuery(window).scrollTop();
       	  var currentScroll1 = jQuery(this).scrollTop();
          var topOfOthDiv = jQuery('#shopify-section-header').height();
          if (currentScroll1 > topOfOthDiv && currentScroll1 < jQuery(document).height() - jQuery(window).height()){
          if (currentScroll1 > previousScroll){

            if(jQuery(window).width()>998) { //Responsive Breakpoint : 998 
                hideNav();

             } else {

                hideMobileNav();
             }

          } else {

            if(jQuery(window).width()>998) { //Responsive Breakpoint : 998 
              showNav();
              
            } else {
              showMobileNav();
            }

          }

          previousScroll = currentScroll1;

          } else {
            if(jQuery("#header_9").length){
                var $search = jQuery('.sticky-right .site-header__search');
              	$search.insertAfter('.topbar-Header .phoneNo');
				var $minicart = jQuery('.sticky-right .mini-cart');
            	$minicart.insertAfter('.topbar-Header .site-header__search');
                jQuery('.sticky-right').remove();
            }
            jQuery('.site-header').removeClass(sticky_nav_class);
            jQuery('header.site-header').removeClass(sticky_nav_class); 
            jQuery(".shop-by-brands").show();
            jQuery('#shopify-section-header').removeAttr("style");

          }
     });
  }
  function stickyHeader(){
    jQuery(window).scroll(function(e){
    	var lastScrollTop = jQuery(".main-content").offset().top;
        lastScrollTop = jQuery('#shopify-section-header').height();
        var st = document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      	//console.log("st " + st + "lastscrolltop " + lastScrollTop );  
      	if (st > lastScrollTop){
          if(jQuery(window).width()>998) { 
             showNav();
            
          } else {
            showMobileNav();
          }
        } else {
          	if(jQuery("#header_9").length){
                var $search = jQuery('.sticky-right .site-header__search');
              	$search.insertAfter('.topbar-Header .phoneNo');
				var $minicart = jQuery('.sticky-right .mini-cart');
            	$minicart.insertAfter('.topbar-Header .site-header__search');
                jQuery('.sticky-right').remove();
            }
          
          	
          
        	jQuery('.site-header').removeClass(sticky_nav_class);
        	jQuery('header.site-header').removeClass(sticky_nav_class); 
        	jQuery(".shop-by-brands").show();
            jQuery('#shopify-section-header').removeAttr("style");
          
         	
          
          

          	
        }
         st = lastScrollTop ;
    });
  }
  function hideNav() 
   {
     
        jQuery('#sticky_minicart').addClass('mobile_cart_fixed').removeClass('cart_fixed').css("top","0px"); 
    	jQuery(".shop-by-brands").show();
     	jQuery('.site-header').removeClass("sticky-is-visible");
		jQuery('.site-header').removeClass(sticky_nav_class);  
     	jQuery('#shopify-section-header').removeAttr("style");
  		jQuery('header.site-header').removeClass(sticky_nav_class); 
     	
   }
   
   function hideMobileNav() 
   {
        jQuery(".shop-by-brands").show();
     	jQuery('#sticky_minicart').addClass('mobile_cart_fixed').removeClass('cart_fixed').css("top","0px"); 	
     	jQuery('header.site-header').removeClass(sticky_nav_class);  
        jQuery('#shopify-section-header').removeAttr("style");
   }
  
   function showNav() 
   {
     	
        
     	jQuery('#shopify-section-header').css("height",jQuery('#shopify-section-header').height());
   	 	jQuery('.sticky-scroll-box').css("top","55px");
        if(jQuery("#header_9").length){
            var stickyEle = jQuery('<div class="sticky-right"></div>');
            if(!jQuery('.sticky-right').length){
          		stickyEle.insertAfter('.nav-outer');
            	var $search = jQuery('.topbar-Header .site-header__search');
            	$search.appendTo('.sticky-right');
            	var $minicart = jQuery('.topbar-Header .mini-cart');
        		$minicart.appendTo('.sticky-right');
            }
        }
     	jQuery('.site-header').addClass(sticky_nav_class);
    	jQuery(".shop-by-brands").hide();
     	
		
       
  	}
   
   	function showMobileNav()
   	{
      	jQuery('.sticky-scroll-box').css("top","40px"); 
        jQuery('#shopify-section-header').css("height",jQuery('#shopify-section-header').height());
        jQuery(".shop-by-brands").hide();
        if(jQuery("#header_9").length){
            var stickyEle = jQuery('<div class="sticky-right"></div>');
            if(!jQuery('.sticky-right').length){
          		stickyEle.insertAfter('.nav-outer');
            	var $search = jQuery('.topbar-Header .site-header__search');
            	$search.appendTo('.sticky-right');
            	var $minicart = jQuery('.topbar-Header .mini-cart');
        		$minicart.appendTo('.sticky-right');
            }
        }
      	jQuery('header.site-header').addClass(sticky_nav_class);
  	}
	
  return {
    init: init,
  }
  
  
})(jQuery);
/*================ End ==============================*/


/*=== Min-Height Elements ================= */
//var alignProductGridActions;

  
var alignProductGridActions = function (elementdiv) {

  //  alert("alighproductgrid");
    var gridRows = []; // This will store an array per row
    var tempRow = [];
 //   productGridElements = jQuery('.grid--view-items > .grid__item'); // old code
   //productGridElements = jQuery('.grid__item');
  productGridElements = jQuery(elementdiv); // dynamic element
	
//console.log("Element :: " + elementdiv);
    productGridElements.each(function (index) {
    
      //alert("alighproductgrid eachrow");
      if (jQuery(this).css('clear') != 'none' && index != 0) {
       
        gridRows.push(tempRow); // Add the previous set of rows to the main array
        tempRow = []; // Reset the array since we're on a new row
      }
      tempRow.push(this);

      if (productGridElements.length == index + 1) {
        gridRows.push(tempRow);
      }
    });
  //console.log("Number of Rows :: " + gridRows.length);
	var i =0;
    setTimeout(function(){
    jQuery.each(gridRows, function () {
     
      //alert("alighproductgrid eachrow");
      var tallestHeight = 0;
      var tallestHeight1 = 0;
      jQuery.each(this, function () {
        jQuery(this).find('.products-details').css('min-height', '');
        jQuery(this).find('.product-image').css('min-height', '');

        elHeight = parseInt(jQuery(this).find('.products-details').css('height'));
        elHeight1 = parseInt(jQuery(this).find('.product-image').css('height'));
		       
        if (elHeight > tallestHeight) { tallestHeight = elHeight; }
        if (elHeight1 > tallestHeight1) { tallestHeight1 = elHeight1; }
      });

     // jQuery.each(this, function () {
        jQuery(this).find('.products-details').css('min-height', tallestHeight);
        jQuery(this).find('.product-image').css('min-height', tallestHeight1);
       //console.log(tallestHeight1);
      	//jQuery(this).find('.products-details').height(tallestHeight);
      	// jQuery(this).find('.proHover').height(tallestHeight1);
      //  jQuery(this).find('.proHover').css('display','block'); // for firefox
        
        //console.log("set product details=>"+tallestHeight);
        //console.log("set prohover=>"+tallestHeight1);
        //alert("test");
     // });
            
    });
   }  , 1000);
  }

/*=== Min-Height Elements Home Page ================= */
  
var alignProductGridActionsHome = function (elementdiv) {
	
  //console.log(elementdiv);
  if(elementdiv == undefined){
  	productGridElements = jQuery('.grid--view-items'); 
  }else{
  	productGridElements = jQuery(elementdiv); 
  }  

    productGridElements.each(function (index) {
    
        var tallestHeight = 0;
        var tallestHeight1 = 0;
        var numofproductsineachrow = 0;
       
      	jQuery(this).find(".grid__item_eqh").each(function (index) {

            jQuery(this).find('.products-details').css('min-height', '');
            jQuery(this).find('.product-image').css('min-height', '');

            elHeight = parseInt(jQuery(this).find('.products-details').css('height'));
            elHeight1 = parseInt(jQuery(this).find('.product-image').css('height'));

            if (elHeight > tallestHeight) { tallestHeight = elHeight; }
            if (elHeight1 > tallestHeight1) { tallestHeight1 = elHeight1; }
          //  numofproductsineachrow = index;
        });

      	//console.log("number of products in each grid-view--item :: " + numofproductsineachrow);
    
        jQuery(this).find('.products-details').css('min-height', tallestHeight);
        jQuery(this).find('.product-image').css('min-height', tallestHeight1);
            
    });
   
  }


if (jQuery('.grid--blog').length) {
  
  var blogGridActions = function () {
    var gridRows = []; 
    var tempRow = [];
    blogGridElements = jQuery('.grid--blog > .grid__item');
    blogGridElements.each(function (index) {

      if (jQuery(this).css('clear') != 'none' && index != 0) {
        gridRows.push(tempRow); 
        tempRow = []; 
      }
      tempRow.push(this);

      if (blogGridElements.length == index + 1) {
        gridRows.push(tempRow);
      }
    });

    jQuery.each(gridRows, function () {
      var tallestHeight = 0;
      var tallestHeight1 = 0;
      var tallestHeight2 = 0;
      jQuery.each(this, function () {
        jQuery(this).find('.blogThumb').css('height', '');
        jQuery(this).find('.article__grid-meta').css('height', '');
        jQuery(this).find('.article__title').css('height', '');
		
        elHeight = parseInt(jQuery(this).find('.blogThumb').height());
        elHeight1 = parseInt(jQuery(this).find('.article__grid-meta').height());
        elHeight2 = parseInt(jQuery(this).find('.article__title').height());

        if (elHeight > tallestHeight) { tallestHeight = elHeight; }
        if (elHeight1 > tallestHeight1) { tallestHeight1 = elHeight1; }
        if (elHeight2 > tallestHeight2) { tallestHeight2 = elHeight2; }
      });

     // jQuery.each(this, function () {
        jQuery(this).find('.blogThumb').css('height', tallestHeight);
        jQuery(this).find('.article__grid-meta').css('height', tallestHeight1);
      	jQuery(this).find('.article__title').css('height', tallestHeight2);
        jQuery(this).find('.blogThumb').css('display','block'); // for firefox
     // });
    });
  }
  blogGridActions();
  // Since the height of each cell and the number of columns per page may change when the page is resized, we are
  // going to run the alignment function each time the page is resized.
  jQuery(window).on('delayed-resize', function (e, resizeEvent) {
    blogGridActions();
  });
}

// ==============================================
// Generic, efficient window resize handler
// ==============================================

// Using setTimeout since Web-Kit and some other browsers call the resize function constantly upon window resizing.
var resizeTimer;
jQuery(window).resize(function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    jQuery(window).trigger('delayed-resize');
  }, 250);
});


/*=== Min-Height Elements ================= */

poshecommerce.addToCartflip = function ($addToCartBtn) {

  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Cart";

  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);

  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
    .text("View cart")
    .end()
    .bind('click', function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
    .addClass('btn--flipped')
    .after('<span class="continue-shopping"><a href="/collections/all">Continue shopping <i aria-hidden="true" class="fa fa-chevron-circle-right"></i></a></span>');

  jQuery('.continue-shopping a').bind('click', poshecommerce.backButton);

  // Unflip button if another variant is selected
  jQuery('.single-option-selector, [name="quantity"]').bind('click', function() {
    jQuery(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    jQuery(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

poshecommerce.enableAjax = function () {
  poshecommerce.cache.$addToCartBtn.bind('click', function(e) {
    e.preventDefault();
    jQuery('.note.errors').remove();
    var $addToCartBtn = jQuery(this),
        $addToCartForm = jQuery(this).closest('form'),
        $addToCartBtnText = jQuery(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled')
        .addClass('btn--loading');
      jQuery.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
          jQuery.getJSON('/cart.js', function(cart) {
            poshecommerce.cache.$cartCount.text(cart.item_count);
            jQuery('.hidden-count').removeClass('hidden-count');
          });
          $addToCartBtn.removeClass('btn--loading');
          poshecommerce.addToCartflip($addToCartBtn);
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && jQuery('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold Out");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
};


! function(ac) {
  
  ac(document).ready(function() {
	 sl.init(), ab.init()
  });
  
  /* Accordian Script For Support & FAQ's --------------  */
  var acc = document.getElementsByClassName("accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }
  /* Accordian Script For Support & FAQ's --------------  */

}(jQuery); 

/*****************Load More Products***********/
var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute() {
  var hT = jQuery('.more').offset().top,
  hH = jQuery('.more').outerHeight(),
  wH = jQuery(window).height(),
  wS = jQuery(this).scrollTop();
    
  if(wS > (hT+hH-wH) && (hT > wS) && (wS+wH > hT+hH)){
 
    pInfScrNode = jQuery('.more').last();	
    pInfScrURL = jQuery('.more a').last().attr("href");
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
      jQuery.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
		  jQuery("body").addClass("loading");
          //jQuery(".product_list").addClass("loading");
         // jQuery(".loadmorecustom").css("display","block");
          pInfScrNode.hide();
        },
        success: function(data) {
          // remove loading feedback
          jQuery("body").removeClass("loading");
          //jQuery("#product-list-foot").addClass("loading");
         // jQuery(".loadmorecustom").css("display","block");
          
          if (jQuery(data).find(".more a").length > 0) {
           
            jQuery(".more").replaceWith(jQuery(data).find(".more"));
            if(jQuery(".more a").attr('href')) {
            
              ShowMoreEvent();
            }
          }
          else {
           
            if(jQuery(".more a").length > 0) {
              jQuery(".more a").remove();
            }
          }
          
         // pInfScrNode.next().remove();
          var filteredData = jQuery(data).find(".addmore");
     
          if (jQuery(data).find(".addmore").length > 0 || jQuery(data).find("#list-view-items").length > 0  ) {
            if (jQuery(data).find(".addmore").length > 0){
            	jQuery(data).find(".addmore > div").each(function() {
              		jQuery('.addmore').append(jQuery(this));
            	});
            }
            if (jQuery(data).find("#list-view-items").length > 0){
              
               if(jQuery("#multi-addToCart").length){
                    jQuery(data).find('#multi-addToCart > tbody').each(function() {
                      jQuery('#multi-addToCart').append(jQuery(this));
                    });
               }
               else{
                   jQuery(data).find("#list-view-items > li").each(function() {
                     jQuery('#list-view-items').append(jQuery(this));
                   });
               }
          	}
            if(jQuery(".spr-badge").length > 0) {
              //this line is added to fix big review star problem in IE11
              jQuery('link[rel=stylesheet][href*="spr"]').remove();
              //ended here
              jQuery.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
			
            wishlist_product_handle();
            Currency.convertAll(Currency.default_curr, Currency.currentCurrency, 'span.money', Currency.format);
          }
          
          pInfScrLoading = false;
          alignProductGridActions('.grid--view-items > .grid__item_eqh'); // product image equal height call
        },
        dataType: "html"
      });
    }
  }
}



/******************* wishlist product check *********************/
wishlist_product_handle()
function wishlist_product_handle(){
 
 		var product_handle_arr = [];
        jQuery('[id^="already_wishlist_"]').hide(); 
        jQuery('[class^="product-actions-"]').each(function() {
            var id = jQuery(this).attr('class');
            var number = id.split('-').pop();
            var product_handle = jQuery('#product_handle_'+number).val();

          product_handle_arr.push({id:id,product_handle:product_handle });
        });
        Shopify.Wishlist.productExists(product_handle_arr);
}
/****************************************************/
